export const collectionToArtistSeriesSlugMap = {
  "agnes-martin-praise": "agnes-martin-praise",
  "ai-weiwei-new-york-photographs": "ai-weiwei-new-york-photographs",
  "ai-weiwei-odyssey": "ai-weiwei-odyssey",
  "ai-weiwei-study-of-perspective": "ai-weiwei-study-of-perspective",
  "alberto-giacometti-busts": "alberto-giacometti-busts",
  "albrecht-durer-adam-and-eve": "albrecht-durer-adam-and-eve",
  "albrecht-durer-christ-on-the-cross": "albrecht-durer-christ-on-the-cross",
  "albrecht-durer-coat-of-arms": "albrecht-durer-coat-of-arms",
  "albrecht-durer-hercules": "albrecht-durer-hercules",
  "albrecht-durer-melencolia": "albrecht-durer-melencolia",
  "albrecht-durer-saint-jerome": "albrecht-durer-saint-jerome",
  "albrecht-durer-the-last-supper": "albrecht-durer-the-last-supper",
  "albrecht-durer-the-rhinoceros": "albrecht-durer-the-rhinoceros",
  "albrecht-durer-virgin-mary": "albrecht-durer-virgin-mary",
  "alec-monopoly-money": "alec-monopoly-money",
  "alec-monopoly-monopoly-man": "alec-monopoly-monopoly-man",
  "alec-monopoly-richie": "alec-monopoly-richie",
  "alex-katz-ada": "alex-katz-ada",
  "alex-katz-black-dress": "alex-katz-black-dress",
  "alex-katz-chance": "alex-katz-chance",
  "alex-katz-coca-cola-girls": "alex-katz-coca-cola-girls",
  "alex-katz-departure": "alex-katz-departure",
  "alex-katz-pas-de-deux": "alex-katz-pas-de-deux",
  "alex-prager-compulsion": "alex-prager-compulsion",
  "alex-prager-face-in-the-crowd": "alex-prager-face-in-the-crowd",
  "alex-prager-polyester": "alex-prager-polyester",
  "alex-prager-the-big-valley": "alex-prager-the-big-valley",
  "alex-prager-week-end": "alex-prager-week-end",
  "alexander-calder-calders-circus": "alexander-calder-calders-circus",
  "alexander-calder-flying-colors": "alexander-calder-flying-colors",
  "alexander-calder-mobiles": "alexander-calder-mobiles",
  "alexander-calder-pyramids": "alexander-calder-pyramids",
  "alexander-calder-spirals": "alexander-calder-spirals",
  "alfred-stieglitz-camera-work": "alfred-stieglitz-camera-work",
  "alfred-stieglitz-equivalents": "alfred-stieglitz-equivalents",
  "alfred-stieglitz-georgia-okeeffe": "alfred-stieglitz-georgia-okeeffe",
  "alfred-stieglitz-lake-george": "alfred-stieglitz-lake-george",
  "alfred-stieglitz-old-and-new-new-york":
    "alfred-stieglitz-old-and-new-new-york",
  "alfred-stieglitz-spring-showers": "alfred-stieglitz-spring-showers",
  "alfred-stieglitz-the-flatiron-building":
    "alfred-stieglitz-the-flatiron-building",
  "alfred-stieglitz-the-hand-of-man": "alfred-stieglitz-the-hand-of-man",
  "alfred-stieglitz-the-steerage": "alfred-stieglitz-the-steerage",
  "alfred-stieglitz-the-terminal": "alfred-stieglitz-the-terminal",
  "alice-neel-mother-and-child": "alice-neel-mother-and-child",
  "alighiero-boetti-arazzi": "alighiero-boetti-arazzi",
  "alighiero-boetti-mappa": "alighiero-boetti-mappa",
  "alighiero-boetti-tutto": "alighiero-boetti-tutto",
  "alma-thomas-resurrection": "alma-thomas-resurrection",
  "alphonse-mucha-biscuits": "alphonse-mucha-biscuits",
  "alphonse-mucha-job": "alphonse-mucha-job",
  "alphonse-mucha-lorenzaccio": "alphonse-mucha-lorenzaccio",
  "alphonse-mucha-moet-and-chandon": "alphonse-mucha-moet-and-chandon",
  "alphonse-mucha-salon-des-cents": "alphonse-mucha-salon-des-cents",
  "alphonse-mucha-seasons": "alphonse-mucha-seasons",
  "ana-mendieta-silueta-series": "ana-mendieta-silueta-series",
  "andre-kertesz-distortion": "andre-kertesz-distortion",
  "andre-kertesz-paris": "andre-kertesz-paris",
  "andre-kertesz-polaroids": "andre-kertesz-polaroids",
  "andre-kertesz-satiric-dancer": "andre-kertesz-satiric-dancer",
  "andreas-gursky-99-cent": "andreas-gursky-99-cent",
  "andreas-gursky-bangkok": "andreas-gursky-bangkok",
  "andreas-gursky-montparnasse": "andreas-gursky-montparnasse",
  "andy-warhol-a-gold-book": "andy-warhol-a-gold-book",
  "andy-warhol-advertisements": "andy-warhol-advertisements",
  "andy-warhol-african-elephant": "andy-warhol-african-elephants",
  "andy-warhol-after-the-party": "andy-warhol-after-the-party",
  "andy-warhol-albert-einstein": "andy-warhol-albert-einstein",
  "andy-warhol-alexander-the-great": "andy-warhol-alexander-the-great",
  "andy-warhol-angels": "andy-warhol-angels",
  "andy-warhol-apple": "andy-warhol-apple",
  "andy-warhol-aretha-franklin": "andy-warhol-aretha-franklin",
  "andy-warhol-art-cash": "andy-warhol-art-cash",
  "andy-warhol-athletes": "andy-warhol-athletes",
  "andy-warhol-bald-eagle": "andy-warhol-bald-eagles",
  "andy-warhol-bananas": "andy-warhol-bananas",
  "andy-warhol-bearbrick": "be-at-rbrick-andy-warhol",
  "andy-warhol-beethoven": "andy-warhol-beethoven",
  "andy-warhol-birmingham-race-riot": "andy-warhol-birmingham-race-riot",
  "andy-warhol-birth-of-venus": "andy-warhol-birth-of-venus",
  "andy-warhol-blackglama": "andy-warhol-blackglama",
  "andy-warhol-brillo-boxes": "andy-warhol-brillo-boxes",
  "andy-warhol-brooklyn-bridge": "andy-warhol-brooklyn-bridge",
  "andy-warhol-camouflage": "andy-warhol-camouflage",
  "andy-warhol-campbells-soup-can": "andy-warhol-campbells-soup-cans",
  "andy-warhol-cats-name-sam": "andy-warhol-cats-name-sam",
  "andy-warhol-celebrity-portraits": "andy-warhol-celebrity-portraits",
  "andy-warhol-christmas": "andy-warhol-christmas",
  "andy-warhol-coca-cola": "andy-warhol-coca-cola",
  "andy-warhol-cologne-cathedral": "andy-warhol-cologne-cathedral",
  "andy-warhol-committee-2000": "andy-warhol-committee-2000",
  "andy-warhol-cowboys-and-indians": "andy-warhol-cowboys-and-indians",
  "andy-warhol-crosses": "andy-warhol-crosses",
  "andy-warhol-dancers": "andy-warhol-dancers",
  "andy-warhol-death-and-disaster": "andy-warhol-death-and-disaster",
  "andy-warhol-debbie-harry": "andy-warhol-debbie-harry",
  "andy-warhol-dennis-hopper": "andy-warhol-dennis-hopper",
  "andy-warhol-details-of-renaissance-paintings":
    "andy-warhol-details-of-renaissance-paintings",
  "andy-warhol-diamond-dust-shoes": "andy-warhol-diamond-dust-shoes",
  "andy-warhol-dollar-sign": "andy-warhol-dollar-sign",
  "andy-warhol-dolly-parton": "andy-warhol-dolly-parton",
  "andy-warhol-donald-duck": "andy-warhol-donald-duck",
  "andy-warhol-dracula": "andy-warhol-dracula",
  "andy-warhol-edvard-munch": "andy-warhol-edvard-munch",
  "andy-warhol-electric-chair": "andy-warhol-electric-chairs",
  "andy-warhol-elizabeth-taylor": "andy-warhol-elizabeth-taylor",
  "andy-warhol-elvis-presley": "andy-warhol-elvis-presley",
  "andy-warhol-endangered-species": "andy-warhol-endangered-species",
  "andy-warhol-eva-mudocci-after-munch": "andy-warhol-eva-mudocci-after-munch",
  "andy-warhol-franz-kafka": "andy-warhol-franz-kafka",
  "andy-warhol-general-custer": "andy-warhol-general-custer",
  "andy-warhol-giant-panda": "andy-warhol-giant-pandas",
  "andy-warhol-goethe": "andy-warhol-goethe",
  "andy-warhol-golda-meir": "andy-warhol-golda-meir",
  "andy-warhol-grace-jones": "andy-warhol-grace-jones",
  "andy-warhol-grace-kelly": "andy-warhol-grace-kelly",
  "andy-warhol-grapes": "andy-warhol-grapes",
  "andy-warhol-green-marilyn": "andy-warhol-green-marilyn",
  "andy-warhol-greta-garbo": "andy-warhol-greta-garbo",
  "andy-warhol-grevys-zebra": "andy-warhol-grevys-zebras",
  "andy-warhol-halston": "andy-warhol-halston",
  "andy-warhol-hamburger": "andy-warhol-hamburger",
  "andy-warhol-hammer-and-sickle": "andy-warhol-hammer-and-sickle",
  "andy-warhol-hand-colored-flowers": "andy-warhol-hand-colored-flowers",
  "andy-warhol-hans-christian-andersen": "andy-warhol-hans-christian-andersen",
  "andy-warhol-happy-butterfly-day": "andy-warhol-happy-butterfly-day",
  "andy-warhol-howdy-doody": "andy-warhol-howdy-doody",
  "andy-warhol-illustrations": "andy-warhol-illustrations",
  "andy-warhol-in-the-bottom-of-my-garden":
    "andy-warhol-in-the-bottom-of-my-garden",
  "andy-warhol-ingrid-bergman": "andy-warhol-ingrid-bergman",
  "andy-warhol-interview-magazine": "andy-warhol-interview-magazine",
  "andy-warhol-jack-nicklaus": "andy-warhol-jack-nicklaus",
  "andy-warhol-jacqueline-kennedy": "andy-warhol-jacqueline-kennedy",
  "andy-warhol-james-dean": "andy-warhol-james-dean",
  "andy-warhol-jane-fonda": "andy-warhol-jane-fonda",
  "andy-warhol-jean-michel-basquiat": "andy-warhol-jean-michel-basquiat",
  "andy-warhol-jimmy-carter": "andy-warhol-jimmy-carter",
  "andy-warhol-john-gotti": "andy-warhol-john-gotti",
  "andy-warhol-john-lennon": "andy-warhol-john-lennon",
  "andy-warhol-john-wayne": "andy-warhol-john-wayne",
  "andy-warhol-joseph-beuys": "andy-warhol-joseph-beuys",
  "andy-warhol-judy-garland": "andy-warhol-judy-garland",
  "andy-warhol-kachina-dolls": "andy-warhol-kachina-dolls",
  "andy-warhol-karen-kain": "andy-warhol-karen-kain",
  "andy-warhol-kiku": "andy-warhol-kiku",
  "andy-warhol-kimiko": "andy-warhol-kimiko",
  "andy-warhol-ladies-and-gentleman": "andy-warhol-ladies-and-gentlemen",
  "andy-warhol-lamentation": "andy-warhol-lamentation",
  "andy-warhol-lenin": "andy-warhol-lenin",
  "andy-warhol-leonardo-da-vinci": "andy-warhol-leonardo-da-vinci",
  "andy-warhol-letter-to-the-world-the-kick":
    "andy-warhol-letter-to-the-world-the-kick",
  "andy-warhol-lifesavers": "andy-warhol-lifesavers",
  "andy-warhol-lincoln-center-ticket": "andy-warhol-lincoln-center-ticket",
  "andy-warhol-liza-minnelli": "andy-warhol-liza-minnelli",
  "andy-warhol-love": "andy-warhol-love",
  "andy-warhol-mammy": "andy-warhol-mammy",
  "andy-warhol-man-ray": "andy-warhol-man-ray",
  "andy-warhol-mao": "andy-warhol-mao",
  "andy-warhol-marilyn-monroe": "andy-warhol-marilyn-monroe",
  "andy-warhol-martha-graham": "andy-warhol-martha-graham",
  "andy-warhol-marx-brothers": "andy-warhol-marx-brothers",
  "andy-warhol-merce-cunningham": "andy-warhol-merce-cunningham",
  "andy-warhol-mercedes-benz": "andy-warhol-mercedes-benz",
  "andy-warhol-mick-jagger": "andy-warhol-mick-jagger",
  "andy-warhol-mickey-mouse": "andy-warhol-mickey-mouse",
  "andy-warhol-mildred-scheel": "andy-warhol-mildred-scheel",
  "andy-warhol-mobilgas": "andy-warhol-mobilgas",
  "andy-warhol-mona-lisa": "andy-warhol-mona-lisa",
  "andy-warhol-moonwalk": "andy-warhol-moonwalk",
  "andy-warhol-mother-and-child": "andy-warhol-mother-and-child",
  "andy-warhol-muhammad-ali": "andy-warhol-muhammad-ali",
  "andy-warhol-myths": "andy-warhol-myths",
  "andy-warhol-neuschwanstein": "andy-warhol-neuschwanstein",
  "andy-warhol-one-dollar-bill": "andy-warhol-dollar-bills",
  "andy-warhol-orange-marilyn": "andy-warhol-orange-marilyn",
  "andy-warhol-orangutan": "andy-warhol-orangutans",
  "andy-warhol-paramount": "andy-warhol-paramount",
  "andy-warhol-pepper-pot": "andy-warhol-pepper-pot",
  "andy-warhol-perrier": "andy-warhol-perrier",
  "andy-warhol-playboy-bunny": "andy-warhol-playboy-bunny",
  "andy-warhol-poinsettias": "andy-warhol-poinsettias",
  "andy-warhol-polaroids": "andy-warhol-polaroids",
  "andy-warhol-queen-beatrix-of-the-netherlands":
    "andy-warhol-queen-beatrix-of-the-netherlands",
  "andy-warhol-queen-elizabeth-ii-of-the-united-kingdom":
    "andy-warhol-queen-elizabeth-ii-of-the-united-kingdom",
  "andy-warhol-querelle": "andy-warhol-querelle",
  "andy-warhol-rebel-without-a-cause-james-dean":
    "andy-warhol-rebel-without-a-cause-james-dean",
  "andy-warhol-red-marilyn": "andy-warhol-red-marilyn",
  "andy-warhol-reigning-queens": "andy-warhol-reigning-queens",
  "andy-warhol-robert-mapplethorpe": "andy-warhol-robert-mapplethorpe",
  "andy-warhol-rolling-stones": "andy-warhol-the-rolling-stones",
  "andy-warhol-saint-apollonia": "andy-warhol-saint-apollonia",
  "andy-warhol-san-francisco-silverspot":
    "andy-warhol-san-francisco-silverspot",
  "andy-warhol-sandh-green-stamps": "andy-warhol-s-and-h-green-stamps",
  "andy-warhol-santa-claus": "andy-warhol-santa-claus",
  "andy-warhol-sarah-bernhardt": "andy-warhol-sarah-bernhardt",
  "andy-warhol-scream": "andy-warhol-the-scream",
  "andy-warhol-sex-parts-and-torsos": "andy-warhol-sex-parts-and-torsos",
  "andy-warhol-shadows": "andy-warhol-shadows",
  "andy-warhol-shoes": "andy-warhol-shoes",
  "andy-warhol-siberian-tiger": "andy-warhol-siberian-tigers",
  "andy-warhol-sidewalk": "andy-warhol-sidewalk",
  "andy-warhol-sigmund-freud": "andy-warhol-sigmund-freud",
  "andy-warhol-sitting-bull": "andy-warhol-sitting-bull",
  "andy-warhol-souper-dress": "andy-warhol-the-souper-dress",
  "andy-warhol-space-fruit": "andy-warhol-space-fruit",
  "andy-warhol-speed-skater": "andy-warhol-speed-skater",
  "andy-warhol-star": "andy-warhol-the-star",
  "andy-warhol-sticky-fingers": "andy-warhol-sticky-fingers",
  "andy-warhol-sunsets": "andy-warhol-sunsets",
  "andy-warhol-superman": "andy-warhol-superman",
  "andy-warhol-sylvester-stallone": "andy-warhol-sylvester-stallone",
  "andy-warhol-teddy-roosevelt": "andy-warhol-teddy-roosevelt",
  "andy-warhol-tom-seaver": "andy-warhol-tom-seaver",
  "andy-warhol-tomato-soup": "andy-warhol-tomato-soup",
  "andy-warhol-toy-paintings": "andy-warhol-toy-paintings",
  "andy-warhol-truman-capote": "andy-warhol-truman-capote",
  "andy-warhol-turtle": "andy-warhol-turtles",
  "andy-warhol-uncle-sam": "andy-warhol-uncle-sam",
  "andy-warhol-volkswagen": "andy-warhol-volkswagen",
  "andy-warhol-vote-mcgovern": "andy-warhol-vote-mcgovern",
  "andy-warhol-washington-monument": "andy-warhol-washington-monument",
  "andy-warhol-watercolor-paint-kit-with-brushes":
    "andy-warhol-watercolor-paint-kit-with-brushes",
  "andy-warhol-watermelon": "andy-warhol-watermelon",
  "andy-warhol-wayne-gretzky": "andy-warhol-wayne-gretzky",
  "andy-warhol-wild-raspberries": "andy-warhol-wild-raspberries",
  "andy-warhol-witch": "andy-warhol-the-witch",
  "andy-warhol-youre-in": "andy-warhol-youre-in",
  "anish-kapoor-mirrors": "anish-kapoor-mirrors",
  "anish-kapoor-shadows": "anish-kapoor-shadows",
  "anni-albers-connections": "anni-albers-connections",
  "anni-albers-knots": "anni-albers-knots",
  "anni-albers-meander": "anni-albers-meander",
  "anni-albers-orchestra": "anni-albers-orchestra",
  "annie-leibovitz-portrait-photography":
    "annie-leibovitz-portrait-photography",
  "ansel-adams-national-parks": "ansel-adams-national-parks",
  "ansel-adams-trees": "ansel-adams-trees",
  "ansel-adams-yosemite": "ansel-adams-yosemite",
  "anselm-kiefer-die-ungeborenen": "anselm-kiefer-die-ungeborenen",
  "anselm-kiefer-morgenthau": "anselm-kiefer-morgenthau",
  "anselm-kiefer-unborn": "anselm-kiefer-the-unborn",
  "anselm-kiefer-velimir-chlebnikov": "anselm-kiefer-velimir-chlebnikov",
  "antoni-tapies-llambrec-material": "antoni-tapies-llambrec-material",
  "antony-gormley-fall": "antony-gormley-fall",
  "antony-gormley-feeling-material": "antony-gormley-feeling-material",
  "antony-gormley-matrix": "antony-gormley-matrix",
  "antony-gormley-rooms": "antony-gormley-rooms",
  "arman-accumulations": "arman-accumulations",
  "arman-guitars": "arman-guitars",
  "arman-musical-instruments": "arman-musical-instruments",
  "arman-paint-tubes": "arman-paint-tubes",
  "arman-venus": "arman-venus",
  "arthur-elgort-ballet": "arthur-elgort-ballet",
  "arthur-elgort-jazz": "arthur-elgort-jazz",
  "arthur-elgort-kate-moss": "arthur-elgort-kate-moss",
  "arthur-elgort-vogue": "arthur-elgort-vogue",
  "auguste-rodin-adam": "auguste-rodin-adam",
  "auguste-rodin-age-of-bronze": "auguste-rodin-the-age-of-bronze",
  "auguste-rodin-balzac": "auguste-rodin-balzac",
  "auguste-rodin-burghers-of-calais": "auguste-rodin-the-burghers-of-calais",
  "auguste-rodin-dancers": "auguste-rodin-dancers",
  "auguste-rodin-eternal-springtime": "auguste-rodin-eternal-springtime",
  "auguste-rodin-eve": "auguste-rodin-eve",
  "auguste-rodin-gates-of-hell": "auguste-rodin-gates-of-hell",
  "auguste-rodin-hands": "auguste-rodin-hands",
  "auguste-rodin-kiss": "auguste-rodin-the-kiss",
  "auguste-rodin-pierre-de-wissant": "auguste-rodin-pierre-de-wissant",
  "auguste-rodin-prodigal-son": "auguste-rodin-the-prodigal-son",
  "auguste-rodin-thinker": "auguste-rodin-the-thinker",
  "auguste-rodin-torsos": "auguste-rodin-torsos",
  "bambi-amy-winehouse": "bambi-amy-winehouse",
  "bambi-lie-lie-land": "bambi-lie-lie-land",
  "bambi-liz-taylor": "bambi-liz-taylor",
  "bambi-madonna": "bambi-madonna",
  "banksy-barcode": "banksy-barcode",
  "banksy-bomb-hugger": "banksy-bomb-hugger",
  "banksy-choose-your-weapon": "banksy-choose-your-weapon",
  "banksy-di-faced-tenner": "banksy-di-faced-tenner",
  "banksy-dismaland": "banksy-dismaland",
  "banksy-donuts": "banksy-donuts",
  "banksy-flower-throwers": "banksy-flower-throwers",
  "banksy-flying-copper": "banksy-flying-copper",
  "banksy-forgive-us-our-trespassing": "banksy-forgive-us-our-trespassing",
  "banksy-girl-with-balloon": "banksy-girl-with-balloon",
  "banksy-golf-sale": "banksy-golf-sale",
  "banksy-grannies": "banksy-grannies",
  "banksy-happy-choppers": "banksy-happy-choppers",
  "banksy-hmv": "banksy-hmv",
  "banksy-i-fought-the-law": "banksy-i-fought-the-law",
  "banksy-jack-and-jill": "banksy-jack-and-jill",
  "banksy-kate-moss": "banksy-kate-moss",
  "banksy-monkeys": "banksy-monkeys",
  "banksy-morons": "banksy-morons",
  "banksy-no-ball-games": "banksy-no-ball-games",
  "banksy-pulp-fiction": "banksy-pulp-fiction",
  "banksy-queen-victoria": "banksy-queen-victoria",
  "banksy-rain": "banksy-rain",
  "banksy-rats": "banksy-rats",
  "banksy-sale-ends-today": "banksy-sale-ends-today",
  "banksy-soup-cans": "banksy-soup-cans",
  "banksy-stop-and-search": "banksy-stop-and-search",
  "banksy-trolleys": "banksy-trolleys",
  "banksy-walled-off-hotel": "banksy-walled-off-hotel",
  "barbara-hepworth-figures": "barbara-hepworth-figures",
  "barbara-hepworth-three-forms": "barbara-hepworth-three-forms",
  "barbara-kruger-dont-make-me-angry": "barbara-kruger-dont-make-me-angry",
  "barbara-kruger-i-shop-therefore-i-am":
    "barbara-kruger-i-shop-therefore-i-am",
  "barry-mcgee-faces": "barry-mcgee-faces",
  "bearbrick-daft-punk": "be-at-rbrick-daft-punk",
  "bearbrick-hero": "be-at-rbrick-hero",
  "bearbrick-sex-pistols": "be-at-rbrick-sex-pistols",
  "bearbrick-sorayama": "be-at-rbrick-sorayama",
  "bearbrick-spongebob": "be-at-rbrick-spongebob",
  "bearbrick-star-wars": "be-at-rbrick-star-wars",
  "bearbrick-the-simpsons": "be-at-rbrick-the-simpsons",
  "beau-dunn-barbie": "beau-dunn-barbies",
  "ben-eine-alphabet": "ben-eine-alphabet",
  "ben-eine-amazement": "ben-eine-amazement",
  "ben-eine-celebrate": "ben-eine-celebrate",
  "ben-eine-change": "ben-eine-change",
  "ben-eine-charming": "ben-eine-charming",
  "ben-eine-hell": "ben-eine-hell",
  "ben-eine-letters": "ben-eine-letters",
  "ben-eine-love": "ben-eine-love",
  "ben-eine-revolution": "ben-eine-revolution",
  "ben-eine-riot": "ben-eine-riot",
  "ben-eine-scary": "ben-eine-scary",
  "ben-eine-soho": "ben-eine-soho",
  "ben-frost-krispy-kreme": "ben-frost-krispy-kreme",
  "ben-frost-mcdonalds": "ben-frost-mcdonalds",
  "bernd-and-hilla-becher-blast-furnaces":
    "bernd-and-hilla-becher-blast-furnaces",
  "bernd-and-hilla-becher-gas-tanks": "bernd-and-hilla-becher-gas-tanks",
  "bernd-and-hilla-becher-grain-elevators":
    "bernd-and-hilla-becher-grain-elevators",
  "bernd-and-hilla-becher-industrial-facades":
    "bernd-and-hilla-becher-industrial-facades",
  "bernd-and-hilla-becher-water-towers": "bernd-and-hilla-becher-water-towers",
  "bernd-and-hilla-becher-winding-towers":
    "bernd-and-hilla-becher-winding-towers",
  "betty-tompkins-apologia": "betty-tompkins-apologia",
  "betty-woodman-vases": "betty-woodman-vases",
  "blek-le-rat-last-tango": "blek-le-rat-last-tango",
  "blek-le-rat-mona-lisa": "blek-le-rat-mona-lisa",
  "blek-le-rat-the-warrior": "blek-le-rat-the-warrior",
  "brice-marden-cold-mountain-series": "brice-marden-cold-mountain-series",
  "brice-marden-red-yellow-blue": "brice-marden-red-yellow-blue",
  "bridget-riley-blaze": "bridget-riley-blaze",
  "bridget-riley-dots": "bridget-riley-dots",
  "bridget-riley-fragments": "bridget-riley-fragments",
  "bridget-riley-stripes": "bridget-riley-stripes",
  "bruce-nauman-clowns": "bruce-nauman-clowns",
  "bruce-nauman-fingers-and-holes": "bruce-nauman-fingers-and-holes",
  "bruce-nauman-holograms": "bruce-nauman-holograms",
  "candida-hofer-libraries": "candida-hofer-libraries",
  "carl-andre-poems": "carl-andre-poems",
  "carlos-cruz-diez-couleur-additive": "carlos-cruz-diez-couleur-additive",
  "carlos-cruz-diez-physichromie": "carlos-cruz-diez-physichromie",
  "carlos-cruz-diez-serie-cardiaca": "carlos-cruz-diez-serie-cardiaca",
  "carlos-cruz-diez-serie-semana": "carlos-cruz-diez-serie-semana",
  "carrie-mae-weems-africa-series": "carrie-mae-weems-africa-series",
  "carrie-mae-weems-kitchen-table-series":
    "carrie-mae-weems-kitchen-table-series",
  "carrie-mae-weems-louisiana-project": "carrie-mae-weems-louisiana-project",
  "carrie-mae-weems-not-manets-type": "carrie-mae-weems-not-manets-type",
  "catherine-opie-domestic": "catherine-opie-domestic",
  "catherine-opie-football": "catherine-opie-football",
  "catherine-opie-modernist": "catherine-opie-the-modernist",
  "chris-burden-bridges": "chris-burden-bridges",
  "chris-ofili-afro-lunar-lovers": "chris-ofili-afro-lunar-lovers",
  "christo-and-jeanne-claude-the-gates": "christo-jeanne-claude-the-gates",
  "christo-floating-piers": "christo-jeanne-claude-floating-piers",
  "christo-wrapped-reichstag": "christo-jeanne-claude-wrapped-reichstag",
  "christo-wrapped-statues": "christo-jeanne-claude-wrapped-statues",
  "christo-wrapped-volkswagen": "christo-jeanne-claude-wrapped-volkswagen",
  "christopher-wool-black-book": "christopher-wool-black-book",
  "christopher-wool-my-house": "christopher-wool-my-house",
  "chuck-close-brad-pitt": "chuck-close-brad-pitt",
  "chuck-close-daguerreotypes": "chuck-close-daguerreotypes-and-woodburytypes",
  "chuck-close-grids": "chuck-close-grids",
  "chuck-close-kate-moss": "chuck-close-kate-moss",
  "chuck-close-lucas": "chuck-close-lucas",
  "chuck-close-philip-glass": "chuck-close-philip-glass",
  "cindy-sherman-centerfolds": "cindy-sherman-centerfolds",
  "cindy-sherman-clowns": "cindy-sherman-clowns",
  "cindy-sherman-fairy-tales": "cindy-sherman-fairy-tales",
  "cindy-sherman-untitled-film-stills": "cindy-sherman-untitled-film-stills",
  "claes-oldenburg-apple-cores": "claes-oldenburg-apple-cores",
  "claes-oldenburg-cakes": "claes-oldenburg-apple-cores",
  "claes-oldenburg-clothespins": "claes-oldenburg-clothespins",
  "claes-oldenburg-food": "claes-oldenburg-food",
  "claes-oldenburg-ice-cream": "claes-oldenburg-ice-cream",
  "claes-oldenburg-mouse": "claes-oldenburg-mouse",
  "claes-oldenburg-plugs": "claes-oldenburg-plugs",
  "claes-oldenburg-pretzels": "claes-oldenburg-pretzels",
  "claes-oldenburg-profiteroles": "claes-oldenburg-profiteroles",
  "claes-oldenburg-shuttlecocks": "claes-oldenburg-shuttlecocks",
  "claes-oldenburg-soft-drum-sets": "claes-oldenburg-soft-drum-sets",
  "claes-oldenburg-soft-sculptures": "claes-oldenburg-soft-sculptures",
  "claes-oldenburg-typewriter-erasers": "claes-oldenburg-typewriter-erasers",
  "claude-monet-argenteuil": "claude-monet-argenteuil",
  "claude-monet-boats": "claude-monet-boats",
  "claude-monet-charing-cross-bridge": "claude-monet-charing-cross-bridge",
  "claude-monet-gardens": "claude-monet-gardens",
  "claude-monet-giverny": "claude-monet-giverny",
  "claude-monet-haystacks": "claude-monet-haystacks",
  "claude-monet-japanese-footbridge": "claude-monet-japanese-footbridge",
  "claude-monet-poplars": "claude-monet-poplars",
  "claude-monet-rouen-cathedral": "claude-monet-rouen-cathedral",
  "claude-monet-sunsets": "claude-monet-sunsets",
  "claude-monet-venice": "claude-monet-venice",
  "claude-monet-waterlillies": "claude-monet-waterlillies",
  "claude-monet-waterloo-bridge": "claude-monet-waterloo-bridge",
  "cleon-peterson-destroying-the-weak": "cleon-peterson-destroying-the-weak",
  "cleon-peterson-donald-trump": "cleon-peterson-donald-trump",
  "cleon-peterson-eclipse": "cleon-peterson-eclipse",
  "cleon-peterson-end-of-empire": "cleon-peterson-end-of-empire",
  "cleon-peterson-endless-sleep": "cleon-peterson-endless-sleep",
  "cleon-peterson-heathens": "cleon-peterson-heathens",
  "cleon-peterson-marchers": "cleon-peterson-marchers",
  "cleon-peterson-nightcrawler": "cleon-peterson-nightcrawler",
  "cleon-peterson-pissers": "cleon-peterson-pissers",
  "cleon-peterson-shepard-fairey": "cleon-peterson-shepard-fairey",
  "cleon-peterson-victory": "cleon-peterson-victory",
  "constantin-brancusi-bird-in-space": "constantin-brancusi-birds",
  "constantin-brancusi-endless-column": "constantin-brancusi-endless-column",
  "constantin-brancusi-kiss": "constantin-brancusi-the-kiss",
  "constantin-brancusi-sleeping-muse": "constantin-brancusi-sleeping-muse",
  "cy-twombly-natural-history": "cy-twombly-natural-history",
  "daido-moriyama-a-room": "daido-moriyama-a-room",
  "daido-moriyama-bye-bye-polaroid": "daido-moriyama-bye-bye-polaroids",
  "daido-moriyama-color-photography": "daido-moriyama-color-photography",
  "daido-moriyama-erotica": "daido-moriyama-erotica",
  "daido-moriyama-farewell-photography": "daido-moriyama-farewell-photography",
  "daido-moriyama-hunter": "daido-moriyama-hunter",
  "daido-moriyama-light-and-shadow": "daido-moriyama-light-and-shadow",
  "daido-moriyama-lips": "daido-moriyama-lips",
  "daido-moriyama-on-the-road": "daido-moriyama-on-the-road",
  "daido-moriyama-polaroid": "daido-moriyama-polaroids",
  "daido-moriyama-record": "daido-moriyama-record",
  "daido-moriyama-shinjuku": "daido-moriyama-shinjuku",
  "daido-moriyama-stray-dog": "daido-moriyama-stray-dog",
  "daido-moriyama-tights": "daido-moriyama-tights",
  "daido-moriyama-tokyo": "daido-moriyama-tokyo",
  "dale-chihuly-baskets": "dale-chihuly-baskets",
  "dale-chihuly-bowls": "dale-chihuly-bowls",
  "dale-chihuly-cylinders": "dale-chihuly-cylinders",
  "dale-chihuly-macchia": "dale-chihuly-macchia",
  "dale-chihuly-persian": "dale-chihuly-persian",
  "dale-chihuly-seaforms": "dale-chihuly-seaforms",
  "dale-chihuly-vases": "dale-chihuly-vases",
  "dale-chihuly-venetians": "dale-chihuly-venetians",
  "damien-hirst-butterflies": "damien-hirst-butterflies",
  "damien-hirst-for-the-love-of-god": "damien-hirst-for-the-love-of-god",
  "damien-hirst-i-love-you": "damien-hirst-i-love-you",
  "damien-hirst-kate-moss": "damien-hirst-kate-moss",
  "damien-hirst-mickey-and-minnie-mouse":
    "damien-hirst-mickey-and-minnie-mouse",
  "damien-hirst-pills-and-medicine": "damien-hirst-pills-and-medicine",
  "damien-hirst-spin-paintings": "damien-hirst-spin-paintings",
  "damien-hirst-spots": "damien-hirst-spots",
  "damien-hirst-the-cure": "damien-hirst-the-cure",
  "damien-hirst-the-last-supper": "damien-hirst-the-last-supper",
  "damien-hirst-the-souls": "damien-hirst-the-souls",
  "damien-hirst-valium": "damien-hirst-valium",
  "dan-flavin-fluorescent-light": "dan-flavin-fluorescent-light",
  "dan-flavin-light-art": "dan-flavin-light-art",
  "dan-flavin-monument-for-v-tatlin": "dan-flavin-monument-for-v-tatlin",
  "danh-vo-letter": "danh-vo-letter",
  "danh-vo-we-the-people": "danh-vo-we-the-people",
  "daniel-arsham-cracked-bear": "daniel-arsham-cracked-bear",
  "daniel-arsham-future-relics": "daniel-arsham-future-relics",
  "daniel-arsham-hallow-figure": "daniel-arsham-hollow-figure",
  "daniel-arsham-hourglass": "daniel-arsham-hourglasses",
  "daniel-arsham-keyboard": "daniel-arsham-keyboards",
  "daniel-arsham-phones": "daniel-arsham-phones",
  "daniel-arsham-sand-circle": "daniel-arsham-sand-circle",
  "david-hammons-body-prints": "david-hammons-body-prints",
  "david-hockney-a-bigger-book": "david-hockney-a-bigger-book",
  "david-hockney-celia": "david-hockney-celia",
  "david-hockney-ipad-drawings": "david-hockney-ipad-drawings",
  "david-hockney-pools": "david-hockney-pools",
  "david-lachapelle-after-the-deluge": "david-lachapelle-after-the-deluge",
  "david-lachapelle-andy-warhol": "david-lachapelle-andy-warhol",
  "david-lachapelle-fashion-photography":
    "david-lachapelle-fashion-photography",
  "david-lachapelle-jesus-is-my-homeboy":
    "david-lachapelle-jesus-is-my-homeboy",
  "david-lachapelle-marilyn-monroe": "david-lachapelle-marilyn-monroe",
  "david-lachapelle-naomi-campbell": "david-lachapelle-naomi-campbell",
  "david-lachapelle-pamela-anderson": "david-lachapelle-pamela-anderson",
  "david-lachapelle-recollections-in-america":
    "david-lachapelle-recollections-in-america",
  "david-shrigley-be-nice": "david-shrigley-be-nice",
  "david-shrigley-dont": "david-shrigley-dont",
  "david-shrigley-its-ok": "david-shrigley-its-ok",
  "david-shrigley-really-good": "david-shrigley-really-good",
  "david-shrigley-sell-your-soul": "david-shrigley-sell-your-soul",
  "david-wojnarowicz-arthur-rimbaud-in-new-york":
    "david-wojnarowicz-arthur-rimbaud-in-new-york",
  "david-yarrow-elephants": "david-yarrow-elephants",
  "david-yarrow-penguins": "david-yarrow-penguins",
  "david-yarrow-the-usual-suspects": "david-yarrow-the-usual-suspects",
  "david-yarrow-tigers": "david-yarrow-tigers",
  "diane-arbus-central-park": "diane-arbus-central-park",
  "diane-arbus-children": "diane-arbus-children",
  "diane-arbus-coney-island": "diane-arbus-coney-island",
  "diane-arbus-identical-twins": "diane-arbus-identical-twins",
  "diane-arbus-masks": "diane-arbus-masks",
  "diane-arbus-nudist-camp": "diane-arbus-nudist-camp",
  "diane-arbus-street-photography": "diane-arbus-street-photography",
  "diego-rivera-workers": "diego-rivera-workers",
  "do-ho-suh-apartments": "do-ho-suh-apartments",
  "do-ho-suh-karma": "do-ho-suh-karma",
  "do-ho-suh-rubbing-loving": "do-ho-suh-rubbing-slash-loving",
  "donald-baechler-york-house-suite": "donald-baechler-york-house-suite",
  "donald-judd-wall-sculptures": "donald-judd-wall-sculptures",
  "donald-sultan-dominos": "donald-sultan-dominos",
  "donald-sultan-lantern-flowers": "donald-sultan-lantern-flowers",
  "donald-sultan-lemons": "donald-sultan-lemons",
  "donald-sultan-mimosas": "donald-sultan-mimosas",
  "donald-sultan-playing-cards": "donald-sultan-playing-cards",
  "donald-sultan-poppies": "donald-sultan-poppies",
  "dorothea-lange-california": "dorothea-lange-california",
  "dorothea-lange-mended-stockings": "dorothea-lange-mended-stockings",
  "dorothea-lange-migrant-mother": "dorothea-lange-migrant-mother",
  "dorothea-lange-migrant-workers": "dorothea-lange-migrant-workers",
  "dorothea-lange-san-francisco": "dorothea-lange-san-francisco",
  "dorothea-lange-white-angel": "dorothea-lange-white-angel",
  "dr-seuss-cat-in-the-hat": "dr-seuss-cat-in-the-hat",
  "dr-seuss-unorthodox-taxidermy": "dr-seuss-unorthodox-taxidermy",
  "dustin-yellin-psychogeography": "dustin-yellin-psychogeography",
  "ed-ruscha-angel": "ed-ruscha-angel",
  "ed-ruscha-hollywood": "ed-ruscha-hollywood",
  "ed-ruscha-mountain-prints": "ed-ruscha-mountain-prints",
  "ed-ruscha-news-mews-pews-brews-stews-dues":
    "ed-ruscha-news-mews-pews-brews-stews-and-dues",
  "ed-ruscha-sin": "ed-ruscha-sin",
  "ed-ruscha-standard-station": "ed-ruscha-standard-station",
  "edgar-degas-ballerinas": "edgar-degas-ballerinas",
  "edgar-degas-bathers": "edgar-degas-bathers",
  "edgar-degas-dancers": "edgar-degas-dancers",
  "edgar-degas-jockeys": "edgar-degas-jockeys",
  "edgar-degas-mary-cassatt-at-the-louvre":
    "edgar-degas-mary-cassatt-at-the-louvre",
  "edgar-degas-milliners": "edgar-degas-milliners",
  "edgar-degas-pastels": "edgar-degas-pastels",
  "edgar-degas-sketches-of-a-caf-singer":
    "edgar-degas-sketches-of-a-caf-singer",
  "edgar-degas-sketches": "edgar-degas-sketches",
  "eduardo-chillida-hands": "eduardo-chillida-hands",
  "edvard-munch-forests": "edvard-munch-forests",
  "edvard-munch-melancholy": "edvard-munch-melancholy",
  "edvard-munch-starry-night": "edvard-munch-starry-night",
  "edvard-munch-the-scream": "edvard-munch-the-scream",
  "edward-burtynsky-china": "edward-burtynsky-china",
  "edward-burtynsky-mines": "edward-burtynsky-mines",
  "edward-burtynsky-oil": "edward-burtynsky-oil",
  "edward-burtynsky-quarries": "edward-burtynsky-quarries",
  "edward-burtynsky-salt-pans": "edward-burtynsky-salt-pans",
  "edward-burtynsky-shipbreaking": "edward-burtynsky-shipbreaking",
  "edward-burtynsky-water": "edward-burtynsky-water",
  "edward-hopper-evening-wind": "edward-hopper-evening-wind",
  "edward-hopper-houses": "edward-hopper-houses",
  "edward-hopper-night-shadows": "edward-hopper-night-shadows",
  "edward-hopper-nighthawks": "edward-hopper-nighthawks",
  "edward-weston-cabbages": "edward-weston-cabbages",
  "edward-weston-desert": "edward-weston-deserts",
  "edward-weston-dunes": "edward-weston-dunes",
  "edward-weston-food": "edward-weston-food",
  "edward-weston-mexico": "edward-weston-mexico",
  "edward-weston-neil": "edward-weston-neil",
  "edward-weston-peppers": "edward-weston-peppers",
  "edward-weston-shells": "edward-weston-shells",
  "edward-weston-tina": "edward-weston-tina",
  "egon-schiele-hands": "egon-schiele-hands",
  "el-anatsui-bottle-caps": "el-anatsui-bottle-caps",
  "elaine-de-kooning-bacchus": "elaine-de-kooning-bacchus",
  "elaine-de-kooning-taurus": "elaine-de-kooning-taurus",
  "elizabeth-peyton-david-bowie": "elizabeth-peyton-david-bowie",
  "elizabeth-peyton-nick": "elizabeth-peyton-nick",
  "ellen-von-unwerth-claudia-schiffer": "ellen-von-unwerth-claudia-schiffer",
  "ellen-von-unwerth-fashion-photography":
    "ellen-von-unwerth-fashion-photography",
  "ellen-von-unwerth-heimat": "ellen-von-unwerth-heimat",
  "ellen-von-unwerth-kate-moss": "ellen-von-unwerth-kate-moss",
  "ellen-von-unwerth-paris": "ellen-von-unwerth-paris",
  "ellen-von-unwerth-peaches-rouilly-le-bas-paris":
    "ellen-von-unwerth-peaches-rouilly-le-bas-paris",
  "ellen-von-unwerth-revenge": "ellen-von-unwerth-revenge",
  "ellen-von-unwerth-the-story-of-olga": "ellen-von-unwerth-the-story-of-olga",
  "elliott-erwitt-california-kiss": "elliott-erwitt-california-kiss",
  "elliott-erwitt-che-guevara": "elliott-erwitt-che-guevara",
  "elliott-erwitt-couple-dancing": "elliott-erwitt-couple-dancing",
  "elliott-erwitt-eiffel-tower": "elliott-erwitt-eiffel-tower",
  "elliott-erwitt-france": "elliott-erwitt-france",
  "elliott-erwitt-jackie-kennedy": "elliott-erwitt-jackie-kennedy",
  "elliott-erwitt-marilyn-monroe": "elliott-erwitt-marilyn-monroe",
  "elliott-erwitt-new-york-city": "elliott-erwitt-new-york-city",
  "elliott-erwitt-nixon": "elliott-erwitt-richard-nixon",
  "elliott-erwitt-north-carolina": "elliott-erwitt-north-carolina",
  "elliott-erwitt-paris": "elliott-erwitt-paris",
  "elliott-erwitt-pittsburgh": "elliott-erwitt-pittsburgh",
  "elliott-erwitt-provence": "elliott-erwitt-provence",
  "elliott-erwitt-wyoming": "elliott-erwitt-wyoming",
  "ellsworth-kelly-line-drawings": "ellsworth-kelly-line-drawings",
  "ellsworth-kelly-plants": "ellsworth-kelly-plants",
  "emil-nolde-hamburg": "emil-nolde-hamburg",
  "ernst-ludwig-kirchner-bathers": "ernst-ludwig-kirchner-bathers",
  "ernst-ludwig-kirchner-dancers": "ernst-ludwig-kirchner-dancers",
  "ernst-ludwig-kirchner-dresden": "ernst-ludwig-kirchner-dresden",
  "erwin-wurm-one-minute-sculptures": "erwin-wurm-one-minute-sculptures",
  "ettore-sottsass-bookshelves": "ettore-sottsass-bookshelves",
  "ettore-sottsass-carlton": "ettore-sottsass-carlton",
  "ettore-sottsass-chairs": "ettore-sottsass-chairs",
  "ettore-sottsass-coffee-tables": "ettore-sottsass-coffee-tables",
  "ettore-sottsass-floor-lamps": "ettore-sottsass-floor-lamps",
  "ettore-sottsass-fruit-bowl": "ettore-sottsass-fruit-bowl",
  "ettore-sottsass-lamps": "ettore-sottsass-lamps",
  "ettore-sottsass-shiva-vases": "ettore-sottsass-shiva-vases",
  "ettore-sottsass-table-lamps": "ettore-sottsass-table-lamps",
  "ettore-sottsass-totems": "ettore-sottsass-totems",
  "ettore-sottsass-vases": "ettore-sottsass-vases",
  "faile-bunnies": "faile-bunnies",
  "faile-mermaids": "faile-mermaids",
  "faile-puzzle-boxes": "faile-puzzle-boxes",
  "faile-star-spangled-shadows": "faile-star-spangled-shadows",
  "faile-sweet-sins": "faile-sweet-sins",
  "faile-visions-victoire": "faile-visions-victoire",
  "faith-ringgold-story-quilts": "faith-ringgold-story-quilts",
  "felix-gonzalez-torres-candy": "felix-gonzalez-torres-candy",
  "felix-gonzalez-torres-double-portrait":
    "felix-gonzalez-torres-double-portrait",
  "felix-gonzalez-torres-light-bulbs": "felix-gonzalez-torres-light-bulbs",
  "fernand-leger-circus": "fernand-leger-circus",
  "fernand-leger-mechanical-elements": "fernand-leger-mechanical-elements",
  "fernand-leger-the-divers": "fernand-leger-the-divers",
  "fernando-botero-circus": "fernando-botero-circus",
  "fos-lighting": "fos-lighting",
  "fos-tables": "fos-tables",
  "fos-vases": "fos-vases",
  "francesca-woodman-houses": "francesca-woodman-houses",
  "francesca-woodman-providence-rhode-island":
    "francesca-woodman-providence-rhode-island",
  "francesca-woodman-rome": "francesca-woodman-rome",
  "francis-bacon-portrait-of-pope": "francis-bacon-portrait-of-pope",
  "francis-bacon-triptychs": "francis-bacon-triptychs",
  "francisco-de-goya-black-paintings": "francisco-de-goya-black-paintings",
  "francisco-de-goya-bullfighting": "francisco-de-goya-bullfighting",
  "francisco-de-goya-disasters-of-war": "francisco-de-goya-disasters-of-war",
  "francisco-de-goya-los-caprichos": "francisco-de-goya-los-caprichos",
  "francisco-de-goya-los-disparates": "francisco-de-goya-los-disparates",
  "francisco-de-goya-los-proverbios": "francisco-de-goya-los-proverbios",
  "francisco-de-goya-maja": "francisco-de-goya-maja",
  "francisco-de-goya-royal-portraits": "francisco-de-goya-royal-portraits",
  "francisco-de-goya-the-sleep-of-reason-produces-monsters":
    "francisco-de-goya-the-sleep-of-reason-produces-monsters",
  "frank-stella-moby-dick": "frank-stella-moby-dick",
  "frank-stella-protractor-series": "frank-stella-protractor-series",
  "frank-stella-shards": "frank-stella-shards",
  "frank-stella-squares": "frank-stella-squares",
  "frank-stella-v-series": "frank-stella-v-series",
  "franz-west-chairs": "franz-west-chairs",
  "franz-west-lamps": "franz-west-lamps",
  "franz-west-outdoor-sculpture": "franz-west-outdoor-sculpture",
  "franz-west-sofa": "franz-west-sofas",
  "franz-west-uncle-chair": "franz-west-uncle-chairs",
  "futura-tag": "futura-tag",
  "gabriel-orozco-circles": "gabriel-orozco-circles",
  "garry-winogrand-los-angeles": "garry-winogrand-los-angeles",
  "garry-winogrand-marilyn-monroe": "garry-winogrand-marilyn-monroe",
  "garry-winogrand-street-photography": "garry-winogrand-street-photography",
  "gene-davis-stripes": "gene-davis-stripes",
  "georg-baselitz-elke": "georg-baselitz-elke",
  "georg-baselitz-remix": "georg-baselitz-remix",
  "georges-braque-birds": "georges-braque-birds",
  "georges-braque-theogonie": "georges-braque-theogonie",
  "georges-braque-violins": "georges-braque-violins",
  "georgia-okeeffe-jack-in-the-pulpit": "georgia-okeeffe-jack-in-the-pulpit",
  "georgia-okeeffe-lake-george": "georgia-okeeffe-lake-george",
  "georgia-okeeffe-new-mexico": "georgia-okeeffe-new-mexico",
  "gerhard-richter-abstraktes-bild": "gerhard-richter-abstraktes-bild",
  "gerhard-richter-bagdad": "gerhard-richter-bagdad",
  "gerhard-richter-bouquets": "gerhard-richter-bouquets",
  "gerhard-richter-eis": "gerhard-richter-eis",
  "gerhard-richter-fences": "gerhard-richter-fences",
  "gerhard-richter-flow": "gerhard-richter-flow",
  "gerhard-richter-haggadahs": "gerhard-richter-haggadahs",
  "gerhard-richter-ohne-titel": "gerhard-richter-ohne-titel",
  "gerhard-richter-squeegee-paintings-and-prints":
    "gerhard-richter-abstractions",
  "gerhard-richter-tulips": "gerhard-richter-tulips",
  "ghada-amer-embroidery": "ghada-amer-embroidery",
  "giorgio-de-chirico-piazza-ditalia": "giorgio-de-chirico-piazza-ditalia",
  "glenn-ligon-america": "glenn-ligon-america",
  "glenn-ligon-negro-sunshine": "glenn-ligon-negro-sunshine",
  "glenn-ligon-neon": "glenn-ligon-neon",
  "glenn-ligon-runaways": "glenn-ligon-runaways",
  "gordon-parks-alabama": "gordon-parks-alabama",
  "gordon-parks-american-gothic": "gordon-parks-american-gothic",
  "gordon-parks-back-to-fort-scott": "gordon-parks-back-to-fort-scott",
  "gordon-parks-civil-rights": "gordon-parks-civil-rights-movement",
  "gordon-parks-color-photography": "gordon-parks-color-photography",
  "gordon-parks-fashion-photography": "gordon-parks-fashion-photography",
  "gordon-parks-harlem": "gordon-parks-harlem",
  "gordon-parks-invisible-man": "gordon-parks-invisible-man",
  "gordon-parks-malcolm-x": "gordon-parks-malcolm-x",
  "gordon-parks-segregation-series": "gordon-parks-segregation-story",
  "grayson-perry-animal-spirits": "grayson-perry-animal-spirits",
  "grayson-perry-bears": "grayson-perry-bears",
  "grayson-perry-comfort-blankets": "grayson-perry-comfort-blankets",
  "grayson-perry-embroidery": "grayson-perry-embroidery",
  "grayson-perry-hold-your-beliefs-lightly":
    "grayson-perry-hold-your-beliefs-lightly",
  "grayson-perry-island-of-bad-art": "grayson-perry-island-of-bad-art",
  "grayson-perry-map-of-days": "grayson-perry-map-of-days",
  "grayson-perry-map-of-nowhere": "grayson-perry-map-of-nowhere",
  "grayson-perry-maps": "grayson-perry-maps",
  "grayson-perry-reclining-artist": "grayson-perry-reclining-artist",
  "grayson-perry-shrines": "grayson-perry-shrines",
  "grayson-perry-stamps": "grayson-perry-stamps",
  "grayson-perry-tapestries": "grayson-perry-tapestries",
  "grayson-perry-vases": "grayson-perry-vases",
  "gregory-crewdson-beneath-the-roses": "gregory-crewdson-beneath-the-roses",
  "gregory-crewdson-cathedral-of-the-pines":
    "gregory-crewdson-cathedral-of-the-pines",
  "gregory-crewdson-production-still": "gregory-crewdson-production-still",
  "gregory-crewdson-twilight": "gregory-crewdson-twilight",
  "gustav-klimt-girl": "gustav-klimt-girl",
  "gustav-klimt-reclining-woman": "gustav-klimt-reclining-woman",
  "gustav-klimt-woman": "gustav-klimt-woman",
  "hank-willis-thomas-branded": "hank-willis-thomas-branded",
  "harland-miller-happiness": "harland-miller-happiness",
  "harland-miller-penguin-prints": "harland-miller-penguin-prints",
  "harland-miller-too-cool-to-lose": "harland-miller-too-cool-to-lose",
  "harland-miller-who-cares-wins": "harland-miller-who-cares-wins",
  "hebru-brantley-fly-boys": "hebru-brantley-flyboys",
  "helen-frankenthaler-aerie": "helen-frankenthaler-aerie",
  "helen-frankenthaler-tales-of-genji": "helen-frankenthaler-tales-of-genji",
  "helmut-newton-black-and-white-photography":
    "helmut-newton-black-and-white-photography",
  "helmut-newton-bordighera": "helmut-newton-bordighera",
  "helmut-newton-color-photography": "helmut-newton-color-photography",
  "helmut-newton-fashion-photography": "helmut-newton-fashion-photography",
  "helmut-newton-sumo": "helmut-newton-sumo",
  "henri-cartier-bresson-behind-the-gare-saint-lazare":
    "henri-cartier-bresson-behind-the-gare-saint-lazare",
  "henri-cartier-bresson-china": "henri-cartier-bresson-china",
  "henri-cartier-bresson-greece": "henri-cartier-bresson-greece",
  "henri-cartier-bresson-hyeres": "henri-cartier-bresson-hyeres",
  "henri-cartier-bresson-india": "henri-cartier-bresson-india",
  "henri-cartier-bresson-italy": "henri-cartier-bresson-italy",
  "henri-cartier-bresson-mexico": "henri-cartier-bresson-mexico",
  "henri-cartier-bresson-paris": "henri-cartier-bresson-paris",
  "henri-cartier-bresson-rue-mouffetard":
    "henri-cartier-bresson-rue-mouffetard",
  "henri-cartier-bresson-russia": "henri-cartier-bresson-russia",
  "henri-cartier-bresson-seville": "henri-cartier-bresson-seville",
  "henri-cartier-bresson-spain": "henri-cartier-bresson-spain",
  "henri-de-toulouse-lautrec-circus": "henri-de-toulouse-lautrec-circus",
  "henri-de-toulouse-lautrec-confetti": "henri-de-toulouse-lautrec-confetti",
  "henri-de-toulouse-lautrec-jane-avril":
    "henri-de-toulouse-lautrec-jane-avril",
  "henri-de-toulouse-lautrec-la-revue-blanche":
    "henri-de-toulouse-lautrec-la-revue-blanche",
  "henri-de-toulouse-lautrec-may-belfort":
    "henri-de-toulouse-lautrec-may-belfort",
  "henri-de-toulouse-lautrec-moulin-rouge":
    "henri-de-toulouse-lautrec-moulin-rouge",
  "henri-de-toulouse-lautrec-reine-de-joie":
    "henri-de-toulouse-lautrec-reine-de-joie",
  "henri-de-toulouse-lautrec-troupe-de-mlle-eglantine":
    "henri-de-toulouse-lautrec-troupe-de-mlle-eglantine",
  "henri-de-toulouse-lautrec-yvette-guilbert":
    "henri-de-toulouse-lautrec-yvette-guilbert",
  "henri-matisse-dancers": "henri-matisse-dancers",
  "henri-matisse-jazz": "henri-matisse-jazz",
  "henri-matisse-odalisque": "henri-matisse-odalisque",
  "henri-matisse-paper-cut-outs": "henri-matisse-paper-cut-outs",
  "henri-matisse-pasiphae": "henri-matisse-pasiphae",
  "henry-moore-elephant-skulls": "henry-moore-elephant-skulls",
  "henry-moore-mother-and-child": "henry-moore-mother-and-child",
  "henry-moore-reclining-figures": "henry-moore-reclining-figures",
  "herb-ritts-beaches": "herb-ritts-beaches",
  "herb-ritts-celebrity-portraits": "herb-ritts-celebrity-portraits",
  "herb-ritts-cindy-crawford": "herb-ritts-cindy-crawford",
  "herb-ritts-david-bowie": "herb-ritts-david-bowie",
  "herb-ritts-fred-with-tires": "herb-ritts-fred-with-tires",
  "herb-ritts-kate-moss": "herb-ritts-kate-moss",
  "herb-ritts-madonna": "herb-ritts-madonna",
  "herb-ritts-male-nudes": "herb-ritts-male-nudes",
  "herb-ritts-naomi-campbell": "herb-ritts-naomi-campbell",
  "herb-ritts-stephanie-seymour": "herb-ritts-stephanie-seymour",
  "herb-ritts-supermodels": "herb-ritts-supermodels",
  "herb-ritts-versace": "herb-ritts-versace",
  "herb-ritts-waterfalls": "herb-ritts-waterfalls",
  "hijack-bubble-gum-girl": "hijack-bubble-gum-girl",
  "hiroshi-sugimoto-architecture": "hiroshi-sugimoto-architecture",
  "hiroshi-sugimoto-dioramas": "hiroshi-sugimoto-dioramas",
  "hiroshi-sugimoto-lightning-fields": "hiroshi-sugimoto-lightning-fields",
  "hiroshi-sugimoto-seascapes": "hiroshi-sugimoto-seascapes",
  "hiroshi-sugimoto-theaters": "hiroshi-sugimoto-theaters",
  "horst-p-horst-coco-chanel": "horst-p-horst-coco-chanel",
  "horst-p-horst-cy-twombly": "horst-p-horst-cy-twombly",
  "horst-p-horst-fashion-photography": "horst-p-horst-fashion-photography",
  "horst-p-horst-hands": "horst-p-horst-hands",
  "horst-p-horst-istanbul": "horst-p-horst-istanbul",
  "horst-p-horst-mainbocher-corset": "horst-p-horst-mainbocher-corset",
  "horst-p-horst-odalisque": "horst-p-horst-odalisque",
  "horst-p-horst-round-the-clock": "horst-p-horst-round-the-clock",
  "horst-p-horst-vogue": "horst-p-horst-vogue",
  "howard-hodgkin-after-degas": "howard-hodgkin-after-degas",
  "howard-hodgkin-arch": "howard-hodgkin-arch",
  "howard-hodgkin-ice": "howard-hodgkin-ice",
  "howard-hodgkin-indian-views": "howard-hodgkin-indian-views",
  "howard-hodgkin-multiplication": "howard-hodgkin-multiplication",
  "howard-hodgkin-swimming": "howard-hodgkin-swimming",
  "hunt-slonem-birds": "hunt-slonem-birds",
  "hunt-slonem-bunnies": "hunt-slonem-bunnies",
  "hunt-slonem-butterflies": "hunt-slonem-butterflies",
  "hush-asiatic": "hush-asiatic",
  "hush-duality": "hush-duality",
  "hush-halos": "hush-halos",
  "hush-retroversion": "hush-retroversion",
  "hush-rouge": "hush-rouge",
  "ian-davenport-poured-lines": "ian-davenport-poured-lines",
  "imi-knoebel-anima-mundi": "imi-knoebel-anima-mundi",
  "imogen-cunningham-frida-kahlo": "imogen-cunningham-frida-kahlo",
  "imogen-cunningham-magnolia-blossom": "imogen-cunningham-magnolia-blossom",
  "imogen-cunningham-martha-graham": "imogen-cunningham-martha-graham",
  "imogen-cunningham-triangles": "imogen-cunningham-triangles",
  "imogen-cunningham-two-callas": "imogen-cunningham-two-callas",
  "imogen-cunningham-unmade-bed": "imogen-cunningham-unmade-bed",
  "invader-aladdin": "invader-aladdin",
  "invader-repetition-variation-evolution":
    "invader-repetition-variation-evolution",
  "invader-rubiks-cubes": "invader-rubiks-cubes",
  "invader-scooters": "invader-scooters",
  "irving-penn-cigarettes": "irving-penn-cigarettes",
  "irving-penn-color-photography": "irving-penn-color-photography",
  "irving-penn-cuzco": "irving-penn-cuzco",
  "irving-penn-fashion-photography": "irving-penn-fashion-photography",
  "irving-penn-kate-moss": "irving-penn-kate-moss",
  "irving-penn-lips": "irving-penn-lips",
  "irving-penn-makeup": "irving-penn-makeup",
  "irving-penn-morocco": "irving-penn-morocco",
  "irving-penn-pablo-picasso": "irving-penn-pablo-picasso",
  "irving-penn-paris": "irving-penn-paris",
  "irving-penn-salvador-dali": "irving-penn-salvador-dali",
  "irving-penn-small-trades": "irving-penn-small-trades",
  "isamu-noguchi-akari-light": "isamu-noguchi-akari-light",
  "isamu-noguchi-chess-table": "isamu-noguchi-chess-table",
  "isamu-noguchi-clocks": "isamu-noguchi-clocks",
  "isamu-noguchi-coffee-tables": "isamu-noguchi-coffee-tables",
  "isamu-noguchi-floor-lamps": "isamu-noguchi-floor-lamps",
  "isamu-noguchi-lamps": "isamu-noguchi-lamps",
  "isamu-noguchi-lighting": "isamu-noguchi-lighting",
  "isamu-noguchi-martha-graham": "isamu-noguchi-martha-graham",
  "isamu-noguchi-rocking-stool": "isamu-noguchi-rocking-stool",
  "isamu-noguchi-stone": "isamu-noguchi-stone",
  "isamu-noguchi-stool": "isamu-noguchi-stools",
  "isamu-noguchi-table-lamp": "isamu-noguchi-table-lamps",
  "isamu-noguchi-table": "isamu-noguchi-tables",
  "jackson-pollock-action-paintings": "jackson-pollock-action-paintings",
  "jackson-pollock-bearbrick": "jackson-pollock-bearbrick",
  "jackson-pollock-silkscreens": "jackson-pollock-silkscreens",
  "jackson-pollock-splatter-paintings": "jackson-pollock-splatter-paintings",
  "james-rosenquist-food": "james-rosenquist-food",
  "james-rosenquist-tripartite-series": "james-rosenquist-tripartite-series",
  "james-turrell-aten-reign": "james-turrell-aten-reign",
  "james-turrell-elliptical-glass": "james-turrell-elliptical-glass",
  "james-turrell-first-light": "james-turrell-first-light",
  "james-turrell-projection-series": "james-turrell-projection-series",
  "james-turrell-roden-crater": "james-turrell-roden-crater",
  "jasper-johns-crosshatch": "jasper-johns-crosshatch",
  "jasper-johns-flags": "jasper-johns-flags",
  "jasper-johns-numbers": "jasper-johns-numbers",
  "jasper-johns-savarin": "jasper-johns-savarin",
  "jasper-johns-targets": "jasper-johns-targets",
  "jaume-plensa-heads": "jaume-plensa-heads",
  "jaume-plensa-song-of-songs": "jaume-plensa-song-of-songs",
  "jaume-plensa-together": "jaume-plensa-together",
  "jean-cocteau-porcelain": "jean-cocteau-porcelain",
  "jean-cocteau-the-white-book": "jean-cocteau-the-white-book",
  "jean-michel-basquiat-album-covers": "jean-michel-basquiat-album-covers",
  "jean-michel-basquiat-bearbrick": "jean-michel-basquiat-bearbrick",
  "jean-michel-basquiat-crowns": "jean-michel-basquiat-crowns",
  "jeff-koons-ballerinas": "jeff-koons-ballerinas",
  "jeff-koons-balloon-dogs": "jeff-koons-balloon-dogs",
  "jeff-koons-celebration": "jeff-koons-celebration",
  "jeff-koons-gazing-balls": "jeff-koons-gazing-balls",
  "jeff-koons-puppies": "jeff-koons-puppies",
  "jeff-koons-split-rockers": "jeff-koons-split-rockers",
  "jeff-wall-black-and-white-photography":
    "jeff-wall-black-and-white-photography",
  "jeff-wall-lightboxes": "jeff-wall-lightboxes",
  "jenny-holzer-benches": "jenny-holzer-benches",
  "jenny-holzer-inflammatory-essays": "jenny-holzer-inflammatory-essays",
  "jenny-holzer-projections": "jenny-holzer-projections",
  "jenny-holzer-survival": "jenny-holzer-survival",
  "jenny-holzer-top-secret": "jenny-holzer-top-secret",
  "jenny-holzer-truisms": "jenny-holzer-truisms",
  "jeppe-hein-balloons": "jeppe-hein-balloons",
  "jeppe-hein-benches": "jeppe-hein-benches",
  "jerkface-donuts": "jerkface-donuts",
  "jesus-rafael-soto-vibration": "jesus-rafael-soto-vibration",
  "jim-dine-birds": "jim-dine-birds",
  "jim-dine-brushes": "jim-dine-brushes",
  "jim-dine-hearts": "jim-dine-hearts",
  "jim-dine-pinocchio": "jim-dine-pinocchio",
  "jim-dine-robes": "jim-dine-robes",
  "jim-dine-tool-box": "jim-dine-tool-box",
  "jim-dine-venus": "jim-dine-venus",
  "joan-miro-la-melodie-acide": "joan-miro-la-melodie-acide",
  "joan-miro-maravillas": "joan-miro-maravillas",
  "joan-miro-pochoir": "joan-miro-pochoir",
  "joan-miro-ubu-roi": "joan-miro-ubu-roi",
  "joan-mitchell-fields": "joan-mitchell-fields",
  "joan-mitchell-sunflowers": "joan-mitchell-sunflowers",
  "joan-mitchell-trees": "joan-mitchell-trees",
  "john-baldessari-dots": "john-baldessari-dots",
  "john-baldessari-double-play": "john-baldessari-double-play",
  "john-baldessari-emojis": "john-baldessari-emojis",
  "john-baldessari-raised-eyebrows-furrowed-foreheads":
    "john-baldessari-raised-eyebrows-slash-furrowed-foreheads",
  "john-chamberlain-car-sculptures": "john-chamberlain-car-sculptures",
  "john-chamberlain-foam-sculptures": "john-chamberlain-foam-sculptures",
  "john-chamberlain-masks": "john-chamberlain-masks",
  "jonas-wood-basketball": "jonas-wood-basketball",
  "jonas-wood-pots": "jonas-wood-pots",
  "josef-albers-formulation-articulation":
    "josef-albers-formulation-articulation",
  "josef-albers-homage-to-the-square": "josef-albers-homage-to-the-square",
  "josef-albers-mitered-squares": "josef-albers-mitered-squares",
  "josef-albers-never-before": "josef-albers-never-before",
  "josef-albers-white-line-squares": "josef-albers-white-line-squares",
  "joseph-beuys-7000": "joseph-beuys-7000",
  "joseph-cornell-birds": "joseph-cornell-birds",
  "joseph-cornell-boxes": "joseph-cornell-boxes",
  "joseph-cornell-medici": "joseph-cornell-medici",
  "joseph-kosuth-ex-libris": "joseph-kosuth-ex-libris",
  "joseph-kosuth-neon": "joseph-kosuth-neon",
  "joseph-kosuth-one-and-three": "joseph-kosuth-one-and-three",
  "josh-smith-basketball": "josh-smith-basketball",
  "josh-smith-palm-trees": "josh-smith-palm-trees",
  "jr-28-millimeters": "jr-28-millimeters",
  "jr-ballet": "jr-ballet",
  "jr-brazil": "jr-brazil",
  "jr-china": "jr-china",
  "jr-ellis-island": "jr-ellis-island",
  "jr-eyes": "jr-eyes",
  "jr-france": "jr-france",
  "jr-giants": "jr-giants",
  "jr-inside-out": "jr-inside-out",
  "jr-the-louvre": "jr-the-louvre",
  "jr-women-are-heroes": "jr-women-are-heroes",
  "jr-wrinkles-of-the-city": "jr-wrinkles-of-the-city",
  "judy-chicago-dinner-party": "judy-chicago-dinner-party",
  "judy-chicago-plates": "judy-chicago-plates",
  "judy-chicago-through-the-flower": "judy-chicago-through-the-flower",
  "juergen-teller-charlotte-rampling": "juergen-teller-charlotte-rampling",
  "juergen-teller-fashion-photography": "juergen-teller-fashion-photography",
  "juergen-teller-kate-moss": "juergen-teller-kate-moss",
  "juergen-teller-kristen-mcmenamy": "juergen-teller-kristen-mcmenamy",
  "juergen-teller-louis-xv": "juergen-teller-louis-xv",
  "juergen-teller-paradis": "juergen-teller-paradis",
  "juergen-teller-paris": "juergen-teller-paris",
  "juergen-teller-vivienne-westwood": "juergen-teller-vivienne-westwood",
  "julian-opie-ruth": "julian-opie-ruth",
  "julian-opie-seoul": "julian-opie-seoul",
  "julian-opie-shahnoza": "julian-opie-shahnoza",
  "julian-opie-sheep": "julian-opie-sheep",
  "julian-opie-walking-in-melbourne": "julian-opie-walking-in-melbourne",
  "julian-opie-walking-in-the-rain": "julian-opie-walking-in-the-rain",
  "julian-opie-walking": "julian-opie-walking",
  "julian-opie-winter": "julian-opie-winter",
  "julian-opie-woman-taking-off-mans-shirt":
    "julian-opie-woman-taking-off-mans-shirt",
  "julian-schnabel-childhood": "julian-schnabel-childhood",
  "julian-schnabel-chinese-paintings": "julian-schnabel-chinese-paintings",
  "julian-schnabel-polaroids": "julian-schnabel-polaroids",
  "julie-mehretu-stadia": "julie-mehretu-stadia",
  "kara-walker-canisters": "kara-walker-canisters",
  "kara-walker-domino-sugar-factory": "kara-walker-domino-sugar-factory",
  "kara-walker-emancipation-approximation":
    "kara-walker-emancipation-approximation",
  "kara-walker-freedom-a-fable": "kara-walker-freedom-a-fable",
  "kara-walker-harpers-pictorial-history-of-the-civil-war":
    "kara-walker-harpers-pictorial-history-of-the-civil-war",
  "kara-walker-sphinx": "kara-walker-sphinx",
  "karel-appel-circus": "karel-appel-circus",
  "kathe-kollwitz-mother-and-child": "kathe-kollwitz-mother-and-child",
  "kathe-kollwitz-war": "kathe-kollwitz-war",
  "katherine-bernhardt-et-phone-home": "katherine-bernhardt-et-phone-home",
  "katherine-bernhardt-merengue": "katherine-bernhardt-merengue",
  "katherine-bernhardt-pink-panther": "katherine-bernhardt-nike-panther",
  "katherine-bernhardt-save-the-amazon": "katherine-bernhardt-save-the-amazon",
  "katherine-bradford-superman": "katherine-bradford-superman",
  "katherine-bradford-swimmers": "katherine-bradford-swimmers",
  "katsu-drones": "katsu-drones",
  "kaws-alone-again": "kaws-alone-again",
  "kaws-along-the-way": "kaws-along-the-way",
  "kaws-astroboy": "kaws-astroboy",
  "kaws-bape": "kaws-bape",
  "kaws-bearbrick": "kaws-bearbrick",
  "kaws-bff": "kaws-bff",
  "kaws-blame-game": "kaws-blame-game",
  "kaws-blitz": "kaws-blitz",
  "kaws-cat-teeth-bank": "kaws-cat-teeth-bank",
  "kaws-chum": "kaws-chum",
  "kaws-clean-slate": "kaws-clean-slate",
  "kaws-companions": "kaws-companions",
  "kaws-dior": "kaws-dior",
  "kaws-dissected-and-flayed-companions":
    "kaws-dissected-and-flayed-companions",
  "kaws-four-foot-companion": "kaws-4-foot-companion",
  "kaws-gone": "kaws-gone",
  "kaws-halloween": "kaws-halloween",
  "kaws-holiday": "kaws-holiday",
  "kaws-kubrick": "kaws-kubrick",
  "kaws-lost-time": "kaws-lost-time",
  "kaws-mount-fuji": "kaws-mount-fuji",
  "kaws-no-ones-home": "kaws-no-ones-home",
  "kaws-passing-through": "kaws-passing-through",
  "kaws-pinocchio": "kaws-pinocchio",
  "kaws-resting-place": "kaws-resting-place",
  "kaws-seeing-watching": "kaws-seeing-slash-watching",
  "kaws-share": "kaws-share",
  "kaws-simpsons-kimpsons": "kaws-simpsons-kimpsons",
  "kaws-small-lie": "kaws-small-lie",
  "kaws-snoopy": "kaws-snoopy",
  "kaws-spongebob": "kaws-spongebob",
  "kaws-star-wars": "kaws-star-wars",
  "kaws-stay-steady": "kaws-stay-steady",
  "kaws-the-news": "kaws-the-news",
  "kaws-the-things-that-comfort": "kaws-the-things-that-comfort",
  "kaws-together": "kaws-together",
  "kaws-tweety": "kaws-tweety",
  "kaws-undercover-bear": "kaws-undercover-bear",
  "kaws-ups-and-downs": "kaws-ups-and-downs",
  "keith-haring-activist-posters": "keith-haring-activist-posters",
  "keith-haring-andy-mouse": "keith-haring-andy-mouse",
  "keith-haring-apocalypse": "keith-haring-apocalypse",
  "keith-haring-bad-boys": "keith-haring-bad-boys",
  "keith-haring-barking-dogs": "keith-haring-barking-dogs",
  "keith-haring-bearbrick": "keith-haring-bearbrick",
  "keith-haring-best-buddies": "keith-haring-best-buddies",
  "keith-haring-blueprint-drawings": "keith-haring-blueprint-drawings",
  "keith-haring-dance": "keith-haring-dance",
  "keith-haring-fertility": "keith-haring-fertility",
  "keith-haring-icons": "keith-haring-icons",
  "keith-haring-lucky-strike": "keith-haring-lucky-strike",
  "keith-haring-pop-shop": "keith-haring-pop-shop",
  "keith-haring-radiant-baby": "keith-haring-radiant-baby",
  "keith-haring-subway-drawings": "keith-haring-subway-drawings",
  "keith-haring-the-story-of-red-and-blue":
    "keith-haring-the-story-of-red-and-blue",
  "keith-haring-ufos": "keith-haring-ufos",
  "ken-price-cups": "ken-price-cups",
  "kenneth-noland-chevron": "kenneth-noland-chevron",
  "kenneth-noland-circles": "kenneth-noland-circles",
  "kenneth-noland-stripes": "kenneth-noland-stripes",
  "kerry-james-marshall-blots": "kerry-james-marshall-blots",
  "kerry-james-marshall-frankenstein": "kerry-james-marshall-frankenstein",
  "kerry-james-marshall-scouts": "kerry-james-marshall-scouts",
  "kiki-smith-tapestries": "kiki-smith-tapestries",
  "larry-bell-barcelona": "larry-bell-barcelona",
  "larry-bell-cubes": "larry-bell-cubes",
  "larry-bell-fractions": "larry-bell-fractions",
  "larry-bell-vapor-drawings": "larry-bell-vapor-drawings",
  "larry-clark-jonathan-velasquez": "larry-clark-jonathan-velasquez",
  "larry-clark-teenage-lust": "larry-clark-teenage-lust",
  "larry-clark-tulsa": "larry-clark-tulsa",
  "le-corbusier-unite-planche": "le-corbusier-unite-planche",
  "lee-ufan-dialogue": "lee-ufan-dialogue",
  "lee-ufan-from-line": "lee-ufan-from-line",
  "lee-ufan-from-point": "lee-ufan-from-point",
  "lee-ufan-with-winds": "lee-ufan-with-winds",
  "liu-bolin-hiding-in-new-york": "liu-bolin-hiding-in-new-york",
  "louise-bourgeois-motherhood-and-family":
    "louise-bourgeois-motherhood-and-family",
  "louise-bourgeois-spiders": "louise-bourgeois-spiders",
  "louise-bourgeois-spirals": "louise-bourgeois-spirals",
  "louise-nevelson-essence-series": "louise-nevelson-essence-series",
  "louise-nevelson-facade-suite": "louise-nevelson-facade-suite",
  "louise-nevelson-wood-sculptures": "louise-nevelson-wood-sculptures",
  "lucian-freud-bella": "lucian-freud-bella",
  "lucian-freud-blond-girl": "lucian-freud-blond-girl",
  "malick-sidibe-nuit-de-noel": "malick-sidibe-nuit-de-noel",
  "man-ray-lips": "man-ray-lips",
  "man-ray-marcel-duchamp": "man-ray-marcel-duchamp",
  "man-ray-rayographs": "man-ray-rayographs",
  "man-ray-the-gift": "man-ray-the-gift",
  "manolo-valdes-butterflies": "manolo-valdes-butterflies",
  "manolo-valdes-las-meninas": "manolo-valdes-las-meninas",
  "manolo-valdes-profiles": "manolo-valdes-profiles",
  "marc-chagall-chagall-bible": "marc-chagall-chagall-bible",
  "marc-chagall-circus": "marc-chagall-circus",
  "marc-chagall-stained-glass": "marc-chagall-stained-glass",
  "marc-quinn-eye-of-history": "marc-quinn-eye-of-history",
  "marc-quinn-fingerprints": "marc-quinn-fingerprints",
  "marc-quinn-irises": "marc-quinn-irises",
  "marc-quinn-kate-moss": "marc-quinn-kate-moss",
  "marc-quinn-labyrinth": "marc-quinn-labyrinth",
  "marcel-duchamp-bicycle-wheel": "marcel-duchamp-bicycle-wheel",
  "marcel-duchamp-box-in-a-valise": "marcel-duchamp-box-in-a-valise",
  "marcel-duchamp-chess": "marcel-duchamp-chess",
  "marcel-duchamp-fountain": "marcel-duchamp-fountain",
  "marcel-duchamp-readymades": "marcel-duchamp-readymades",
  "marcel-dzama-ballet": "marcel-dzama-ballet",
  "margaret-bourke-white-chrysler-building":
    "margaret-bourke-white-chrysler-building",
  "margaret-bourke-white-fort-peck-dam": "margaret-bourke-white-fort-peck-dam",
  "margaret-bourke-white-louisville-flood":
    "margaret-bourke-white-louisville-flood",
  "marilyn-minter-lips": "marilyn-minter-lips",
  "marilyn-minter-miley-cyrus": "marilyn-minter-miley-cyrus",
  "marilyn-minter-pamela-anderson": "marilyn-minter-pamela-anderson",
  "marilyn-minter-portraits-of-her-mom": "marilyn-minter-portraits-of-her-mom",
  "marina-abramovic-crystals": "marina-abramovic-crystals",
  "marina-abramovic-performance-art": "marina-abramovic-performance-art",
  "mark-ryden-giclee": "mark-ryden-giclee",
  "mark-ryden-girls": "mark-ryden-girls",
  "marlene-dumas-alan-turing": "marlene-dumas-alan-turing",
  "marlene-dumas-faceless": "marlene-dumas-faceless",
  "martin-schoeller-celebrity-portraits":
    "martin-schoeller-celebrity-portraits",
  "martin-schoeller-female-bodybuilders":
    "martin-schoeller-female-bodybuilders",
  "martin-schoeller-george-clooney": "martin-schoeller-george-clooney",
  "martin-schoeller-prince": "martin-schoeller-prince",
  "martin-schoeller-twins": "martin-schoeller-twins",
  "mary-cassatt-afternoon-tea-party": "mary-cassatt-afternoon-tea-party",
  "mary-cassatt-armchairs": "mary-cassatt-armchairs",
  "mary-cassatt-babies": "mary-cassatt-babies",
  "mary-cassatt-drypoint": "mary-cassatt-drypoint",
  "mary-cassatt-in-the-omnibus": "mary-cassatt-in-the-omnibus",
  "mary-cassatt-in-the-opera": "mary-cassatt-in-the-opera",
  "mary-cassatt-lydia": "mary-cassatt-lydia",
  "mary-cassatt-mandolin-player": "mary-cassatt-mandolin-player",
  "mary-cassatt-margot": "mary-cassatt-margot",
  "mary-cassatt-maternal-caress": "mary-cassatt-maternal-caress",
  "mary-cassatt-mother-and-child": "mary-cassatt-mother-and-child",
  "mary-cassatt-pastels": "mary-cassatt-pastels",
  "mary-cassatt-sketches": "mary-cassatt-sketches",
  "mary-cassatt-the-bath": "mary-cassatt-the-bath",
  "mary-cassatt-the-coiffure": "mary-cassatt-the-coiffure",
  "mary-cassatt-the-fitting": "mary-cassatt-the-fitting",
  "mary-cassatt-the-lamp": "mary-cassatt-the-lamp",
  "maurizio-cattelan-love": "maurizio-cattelan-love",
  "maurizio-cattelan-picasso": "maurizio-cattelan-picasso",
  "maurizio-cattelan-the-end": "maurizio-cattelan-the-end",
  "max-ernst-oiseaux": "max-ernst-birds",
  "mel-bochner-blah-blah-blah": "mel-bochner-blah-blah-blah",
  "mel-bochner-cubes": "mel-bochner-cubes",
  "mel-bochner-measurements": "mel-bochner-measurements",
  "mel-bochner-text": "mel-bochner-text",
  "meret-oppenheim-table": "meret-oppenheim-tables",
  "meret-oppenheim-traccia-table": "meret-oppenheim-traccia-tables",
  "michael-craig-martin-book": "michael-craig-martin-books",
  "michael-craig-martin-glasses": "michael-craig-martin-glasses",
  "michael-craig-martin-headphones": "michael-craig-martin-headphones",
  "michael-craig-martin-intimate-relations":
    "michael-craig-martin-intimate-relations",
  "michael-craig-martin-lightbulbs": "michael-craig-martin-lightbulbs",
  "michael-craig-martin-objects-of-our-time":
    "michael-craig-martin-objects-of-our-time",
  "michael-craig-martin-shoes": "michael-craig-martin-shoes",
  "michael-craig-martin-umbrellas": "michael-craig-martin-umbrellas",
  "michael-craig-martin-watches": "michael-craig-martin-watches",
  "michael-wolf-architecture-of-density":
    "michael-wolf-1954-2019-architecture-of-density",
  "michael-wolf-hong-kong": "michael-wolf-1954-2019-hong-kong",
  "michael-wolf-paris-rooftops": "michael-wolf-1954-2019-paris-rooftops",
  "michael-wolf-paris-street-view": "michael-wolf-1954-2019-paris-street-view",
  "michael-wolf-paris": "michael-wolf-1954-2019-paris",
  "michael-wolf-tokyo-compression": "michael-wolf-1954-2019-tokyo-compression",
  "michael-wolf-transparent-city": "michael-wolf-1954-2019-transparent-city",
  "mickalene-thomas-racquel": "mickalene-thomas-racquel",
  "mickalene-thomas-rhinestones": "mickalene-thomas-rhinestones",
  "mike-kelley-day-is-done": "mike-kelley-day-is-done",
  "miles-aldridge-after-cattelan": "miles-aldridge-after-cattelan",
  "miles-aldridge-i-only-want-you-to-love-me":
    "miles-aldridge-i-only-want-you-to-love-me",
  "miles-aldridge-lips": "miles-aldridge-lips",
  "miles-aldridge-new-utopias": "miles-aldridge-new-utopias",
  "mr-brainwash-albert-einstein": "mr-brainwash-albert-einstein",
  "mr-brainwash-alfred-hitchcock": "mr-brainwash-alfred-hitchcock",
  "mr-brainwash-batman": "mr-brainwash-batman",
  "mr-brainwash-beatles": "mr-brainwash-beatles",
  "mr-brainwash-charlie-chaplin": "mr-brainwash-charlie-chaplin",
  "mr-brainwash-david-bowie": "mr-brainwash-david-bowie",
  "mr-brainwash-elvis-presley": "mr-brainwash-elvis-presley",
  "mr-brainwash-follow-your-dreams": "mr-brainwash-follow-your-dreams",
  "mr-brainwash-jimi-hendrix": "mr-brainwash-jimi-hendrix",
  "mr-brainwash-juxtapose": "mr-brainwash-juxtapose",
  "mr-brainwash-kate-moss": "mr-brainwash-kate-moss",
  "mr-brainwash-life-is-beautiful": "mr-brainwash-life-is-beautiful",
  "mr-brainwash-madonna": "mr-brainwash-madonna",
  "mr-brainwash-marilyn-monroe": "mr-brainwash-marilyn-monroe",
  "mr-brainwash-minnie-and-mickey-mouse":
    "mr-brainwash-minnie-and-mickey-mouse",
  "mr-brainwash-smile": "mr-brainwash-smile",
  "mr-brainwash-spiderman": "mr-brainwash-spiderman",
  "mr-brainwash-spray-cans": "mr-brainwash-spray-cans",
  "mr-brainwash-work-well-together": "mr-brainwash-work-well-together",
  "nam-june-paik-robot": "nam-june-paik-robot",
  "nam-june-paik-tv": "nam-june-paik-tv",
  "nan-goldin-berlin": "nan-goldin-berlin",
  "nan-goldin-paris": "nan-goldin-paris",
  "nick-cave-hustle-coats": "nick-cave-hustle-coats",
  "nick-cave-soundsuits": "nick-cave-soundsuits",
  "nick-cave-tondo": "nick-cave-tondo",
  "niki-de-saint-phalle-nana": "niki-de-saint-phalle-nana",
  "niki-de-saint-phalle-snakes": "niki-de-saint-phalle-snakes",
  "niki-de-saint-phalle-sphinxes": "niki-de-saint-phalle-sphinxes",
  "niki-de-saint-phalle-tarot": "niki-de-saint-phalle-tarot",
  "niki-de-saint-phalle-totems": "niki-de-saint-phalle-totems",
  "nobuyoshi-araki-erotos": "nobuyoshi-araki-erotos",
  "nobuyoshi-araki-kaori": "nobuyoshi-araki-kaori",
  "nobuyoshi-araki-kinbaku": "nobuyoshi-araki-kinbaku",
  "nobuyoshi-araki-polaroids": "nobuyoshi-araki-polaroids",
  "nobuyoshi-araki-sentimental-voyage": "nobuyoshi-araki-sentimental-voyage",
  "nobuyoshi-araki-tokyo-comedy": "nobuyoshi-araki-tokyo-comedy",
  "olafur-eliasson-iceland-series": "olafur-eliasson-iceland-series",
  "olafur-eliasson-waterfalls": "olafur-eliasson-waterfalls",
  "on-kawara-date-paintings": "on-kawara-date-paintings",
  "on-kawara-i-am-still-alive": "on-kawara-i-am-still-alive",
  "on-kawara-i-got-up": "on-kawara-i-got-up",
  "on-kawara-i-met": "on-kawara-i-met",
  "on-kawara-i-went": "on-kawara-i-went",
  "on-kawara-one-million-years": "on-kawara-one-million-years",
  "on-kawara-postcards": "on-kawara-postcards",
  "on-kawara-telegrams": "on-kawara-telegrams",
  "oscar-niemeyer-alta-chair": "oscar-niemeyer-alta-chair",
  "oscar-niemeyer-chairs": "oscar-niemeyer-chairs",
  "oscar-niemeyer-chaise-lounges": "oscar-niemeyer-chaise-lounges",
  "oscar-niemeyer-sofas": "oscar-niemeyer-sofas",
  "oscar-niemeyer-tables": "oscar-niemeyer-tables",
  "pablo-picasso-156-suite": "pablo-picasso-156-suite",
  "pablo-picasso-347-suite": "pablo-picasso-347-suite",
  "pablo-picasso-bulls": "pablo-picasso-bulls",
  "pablo-picasso-cubist-period": "pablo-picasso-cubist-period",
  "pablo-picasso-dancers": "pablo-picasso-dancers",
  "pablo-picasso-doves": "pablo-picasso-doves",
  "pablo-picasso-fish": "pablo-picasso-fish",
  "pablo-picasso-honore-de-balzac": "pablo-picasso-honore-de-balzac",
  "pablo-picasso-linocuts": "pablo-picasso-linocuts",
  "pablo-picasso-owls": "pablo-picasso-owls",
  "pablo-picasso-picadors": "pablo-picasso-picadors",
  "pablo-picasso-portraits-of-artists-and-sculptors":
    "pablo-picasso-portraits-of-artists-and-sculptors",
  "pablo-picasso-portraits-of-his-lovers":
    "pablo-picasso-portraits-of-his-lovers",
  "pablo-picasso-saltimbanques-suite": "pablo-picasso-saltimbanques-suite",
  "pablo-picasso-vollard-suite": "pablo-picasso-vollard-suite",
  "pablo-picasso-weeping-woman": "pablo-picasso-weeping-women",
  "paola-pivi-bears": "paola-pivi-bears",
  "paola-pivi-pearls": "paola-pivi-pearls",
  "parra-no-work-today": "parra-no-work-today",
  "parra-silkscreens": "parra-silkscreens",
  "parra-sliding-doors": "parra-sliding-doors",
  "pat-steir-waterfall": "pat-steir-waterfalls",
  "patrick-demarchelier-christy-turlington":
    "patrick-demarchelier-christy-turlington",
  "patrick-demarchelier-fashion-photography":
    "patrick-demarchelier-fashion-photography",
  "patrick-demarchelier-kate-moss": "patrick-demarchelier-kate-moss",
  "patrick-demarchelier-vogue": "patrick-demarchelier-vogue",
  "patrick-hughes-banksy": "patrick-hughes-banksy",
  "patrick-hughes-rainbows": "patrick-hughes-rainbows",
  "patrick-hughes-reverspective": "patrick-hughes-reverspective",
  "paul-gauguin-monotypes": "paul-gauguin-monotypes",
  "paul-gauguin-religion": "paul-gauguin-religion",
  "paul-gauguin-tahiti": "paul-gauguin-tahiti",
  "paul-jenkins-phenomena": "paul-jenkins-phenomena",
  "paula-modersohn-becker-portrait": "paula-modersohn-becker-portrait",
  "peter-beard-diaries": "peter-beard-diaries",
  "peter-blake-andy-warhol": "peter-blake-andy-warhol",
  "peter-blake-babe-rainbow": "peter-blake-babe-rainbow",
  "peter-blake-circus": "peter-blake-circus",
  "peter-blake-eiffel-tower": "peter-blake-eiffel-tower",
  "peter-blake-elvis-presley": "peter-blake-elvis-presley",
  "peter-blake-homage-to-damien-hirst": "peter-blake-homage-to-damien-hirst",
  "peter-blake-homage-to-rauschenberg": "peter-blake-homage-to-rauschenberg",
  "peter-blake-i-love-you": "peter-blake-i-love-you",
  "peter-blake-london": "peter-blake-london",
  "peter-blake-marilyn-monroe": "peter-blake-marilyn-monroe",
  "peter-blake-sgt-peppers-lonely-hearts-club-band":
    "peter-blake-sgt-peppers-lonely-hearts-club-band",
  "peter-blake-silkscreens": "peter-blake-silkscreens",
  "peter-blake-tattooed-people": "peter-blake-tattooed-people",
  "peter-blake-the-beatles": "peter-blake-the-beatles",
  "peter-blake-union-flag": "peter-blake-union-flag",
  "peter-blake-venice": "peter-blake-venice",
  "peter-doig-100-years-ago": "peter-doig-100-years-ago",
  "peter-doig-canoe": "peter-doig-canoes",
  "peter-doig-lapeyrouse-wall": "peter-doig-lapeyrouse-wall",
  "peter-halley-prisons": "peter-halley-prisons",
  "peter-hujar-david-wojnarowicz": "peter-hujar-david-wojnarowicz",
  "peter-max-angels": "peter-max-angels",
  "peter-max-barack-obama": "peter-max-barack-obama",
  "peter-max-better-world": "peter-max-better-world",
  "peter-max-blushing-beauty": "peter-max-blushing-beauty",
  "peter-max-disney-suite": "peter-max-disney-suite",
  "peter-max-flags": "peter-max-flags",
  "peter-max-hearts": "peter-max-hearts",
  "peter-max-liberty-head": "peter-max-liberty-head",
  "peter-max-mickey-mouse": "peter-max-mickey-mouse",
  "peter-max-statue-of-liberty": "peter-max-statue-of-liberty",
  "peter-max-sun": "peter-max-sun",
  "peter-max-umbrella-man": "peter-max-umbrella-man",
  "peter-max-vase-of-flowers": "peter-max-vase-of-flowers",
  "peter-max-without-borders": "peter-max-without-borders",
  "peter-max-zero": "peter-max-zero",
  "philip-guston-cherries": "philip-guston-cherries",
  "pose-couples-therapy": "pose-couples-therapy",
  "pose-dolls": "pose-dolls",
  "pose-drown": "pose-drown",
  "pose-gents": "pose-gents",
  "pose-mirrors": "pose-mirrors",
  "rashid-johnson-anxious-men": "rashid-johnson-anxious-men",
  "raymond-pettibon-baseball": "raymond-pettibon-baseball",
  "raymond-pettibon-plots-on-loan": "raymond-pettibon-plots-on-loan",
  "rembrandt-van-rijn-adam-and-eve": "rembrandt-van-rijn-adam-and-eve",
  "rembrandt-van-rijn-beggars": "rembrandt-van-rijn-beggars",
  "rembrandt-van-rijn-faust": "rembrandt-van-rijn-faust",
  "rembrandt-van-rijn-joseph-telling-his-dreams":
    "rembrandt-van-rijn-joseph-telling-his-dreams",
  "rembrandt-van-rijn-king-david": "rembrandt-van-rijn-king-david",
  "rembrandt-van-rijn-st-jerome": "rembrandt-van-rijn-st-jerome",
  "rembrandt-van-rijn-the-adoration-of-the-shepherds":
    "rembrandt-van-rijn-the-adoration-of-the-shepherds",
  "rembrandt-van-rijn-the-artists-mother":
    "rembrandt-van-rijn-the-artists-mother",
  "rembrandt-van-rijn-the-descent-from-the-cross":
    "rembrandt-van-rijn-the-descent-from-the-cross",
  "rembrandt-van-rijn-the-flight-into-egypt":
    "rembrandt-van-rijn-the-flight-into-egypt",
  "rembrandt-van-rijn-the-jewish-bride": "rembrandt-van-rijn-the-jewish-bride",
  "rembrandt-van-rijn-the-raising-of-lazarus":
    "rembrandt-van-rijn-the-raising-of-lazarus",
  "rembrandt-van-rijn-the-return-of-the-prodigal-son":
    "rembrandt-van-rijn-the-return-of-the-prodigal-son",
  "rembrandt-van-rijn-the-stoning-of-saint-stephen":
    "rembrandt-van-rijn-the-stoning-of-saint-stephen",
  "rembrandt-van-rijn-titus": "rembrandt-van-rijn-titus",
  "rene-magritte-apples": "rene-magritte-apples",
  "rene-magritte-bowler-hats": "rene-magritte-bowler-hats",
  "rene-magritte-clouds": "rene-magritte-clouds",
  "rene-magritte-pipes": "rene-magritte-pipes",
  "rene-magritte-son-of-man": "rene-magritte-the-son-of-man",
  "retna-braddock-tiles": "retna-braddok-tiles",
  "richard-anuszkiewicz-inward-eye-portfolio":
    "richard-anuszkiewicz-inward-eye-portfolio",
  "richard-anuszkiewicz-rranslumina-series":
    "richard-anuszkiewicz-translumina-series",
  "richard-anuszkiewicz-sequential": "richard-anuszkiewicz-sequential",
  "richard-anuszkiewicz-spectral": "richard-anuszkiewicz-spectral",
  "richard-avedon-celebrities": "richard-avedon-celebrities",
  "richard-avedon-fashion-photography": "richard-avedon-fashion-photography",
  "richard-avedon-the-beatles": "richard-avedon-the-beatles",
  "richard-diebenkorn-albuquerque": "richard-diebenkorn-albuquerque",
  "richard-diebenkorn-berkeley": "richard-diebenkorn-berkeley",
  "richard-diebenkorn-ocean-park": "richard-diebenkorn-ocean-park",
  "richard-estes-holland-hotel": "richard-estes-holland-hotel",
  "richard-estes-salzburg-cathedral": "richard-estes-salzburg-cathedral",
  "richard-hambleton-horse-and-rider": "richard-hambleton-horse-and-rider",
  "richard-hamilton-beatles": "richard-hamilton-the-beatles",
  "richard-hamilton-bronze-by-gold": "richard-hamilton-bronze-by-gold",
  "richard-hamilton-guggenheim": "richard-hamilton-the-guggenheim",
  "richard-hamilton-he-foresaw-his-pale-body":
    "richard-hamilton-he-foresaw-his-pale-body",
  "richard-hamilton-just-what-is-it-that-makes-todays-home-so-different":
    "richard-hamilton-just-what-is-it-that-makes-todays-home-so-different",
  "richard-hamilton-kent-state": "richard-hamilton-kent-state",
  "richard-hamilton-lobby": "richard-hamilton-lobby",
  "richard-hamilton-marcel-duchamp": "richard-hamilton-marcel-duchamp",
  "richard-hamilton-polaroid-portraits": "richard-hamilton-polaroid-portraits",
  "richard-hamilton-polaroids": "richard-hamilton-polaroids",
  "richard-hamilton-release": "richard-hamilton-release",
  "richard-hamilton-swingeing-london": "richard-hamilton-swingeing-london",
  "richard-long-circles": "richard-long-circles",
  "richard-long-handprints": "richard-long-handprints",
  "richard-long-mud-drawings": "richard-long-mud-drawings",
  "richard-long-walks": "richard-long-walks",
  "richard-misrach-deserts": "richard-misrach-deserts",
  "richard-misrach-golden-gate-bridge": "richard-misrach-golden-gate-bridge",
  "richard-misrach-graffiti": "richard-misrach-graffiti",
  "richard-mosse-congo": "richard-mosse-congo",
  "richard-mosse-enclave": "richard-mosse-enclave",
  "richard-mosse-heat-maps": "richard-mosse-heat-maps",
  "richard-mosse-incoming": "richard-mosse-incoming",
  "richard-mosse-infra": "richard-mosse-infra",
  "richard-orlinski-crocodiles": "richard-orlinski-crocodiles",
  "richard-orlinski-lions": "richard-orlinski-lions",
  "richard-orlinski-panthers": "richard-orlinski-panthers",
  "richard-orlinski-t-rex": "richard-orlinski-t-rex",
  "richard-orlinski-wild-kong": "richard-orlinski-wild-kong",
  "richard-prince-cowboys": "richard-prince-cowboys",
  "richard-prince-de-kooning": "richard-prince-de-kooning",
  "richard-prince-girlfriends": "richard-prince-girlfriends",
  "richard-prince-jokes": "richard-prince-jokes",
  "richard-prince-new-figures": "richard-prince-new-figures",
  "richard-prince-nurses": "richard-prince-nurses",
  "richard-serra-ballast": "richard-serra-ballast",
  "richard-serra-equal": "richard-serra-equal",
  "richard-serra-finally-finished": "richard-serra-finally-finished",
  "richard-serra-junction": "richard-serra-junction",
  "richard-serra-rift": "richard-serra-rift",
  "richard-serra-sketches": "richard-serra-sketches",
  "rob-pruitt-pandas": "rob-pruitt-pandas",
  "robert-frank-contact-sheets": "robert-frank-contact-sheets",
  "robert-frank-the-americans": "robert-frank-the-americans",
  "robert-indiana-decade-autoportraits": "robert-indiana-decade-autoportraits",
  "robert-indiana-hartley-elegies": "robert-indiana-hartley-elegies",
  "robert-indiana-heal": "robert-indiana-heal",
  "robert-indiana-hope": "robert-indiana-hope",
  "robert-indiana-love-is-god": "robert-indiana-love-is-god",
  "robert-indiana-love": "robert-indiana-love",
  "robert-indiana-mother-of-us-all": "robert-indiana-mother-of-us-all",
  "robert-indiana-numbers": "robert-indiana-numbers",
  "robert-indiana-the-american-dreams-portfolio":
    "robert-indiana-the-american-dream-portfolio",
  "robert-longo-forests": "robert-longo-forests",
  "robert-longo-heroes": "robert-longo-heroes",
  "robert-longo-men-in-the-cities": "robert-longo-men-in-the-cities",
  "robert-longo-sharks": "robert-longo-sharks",
  "robert-longo-tigers": "robert-longo-tigers",
  "robert-longo-waves": "robert-longo-waves",
  "robert-mapplethorpe-ken-moody-portfolio":
    "robert-mapplethorpe-ken-moody-portfolio",
  "robert-mapplethorpe-lisa-lyon": "robert-mapplethorpe-lisa-lyon",
  "robert-mapplethorpe-patti-smith": "robert-mapplethorpe-patti-smith",
  "robert-mapplethorpe-thomas": "robert-mapplethorpe-thomas",
  "robert-motherwell-elegy-to-the-spanish-republic":
    "robert-motherwell-elegy-to-the-spanish-republic",
  "robert-motherwell-music": "robert-motherwell-music",
  "robert-motherwell-three-poems-octavio-paz":
    "robert-motherwell-three-poems-slash-octavio-paz",
  "robert-rauschenberg-features-from-currents":
    "robert-rauschenberg-features-from-currents",
  "robert-rauschenberg-silkscreens": "robert-rauschenberg-silkscreens",
  "romare-bearden-jazz-series": "romare-bearden-jazz-series",
  "romare-bearden-mother-and-child": "romare-bearden-mother-and-child",
  "romare-bearden-music": "romare-bearden-music",
  "romare-bearden-slave-ships": "romare-bearden-slave-ships",
  "romero-britto-bears": "romero-britto-bears",
  "romero-britto-heart": "romero-britto-hearts",
  "ron-english-abraham-obama": "ron-english-abraham-obama",
  "ron-english-cereal-killers": "ron-english-cereal-killers",
  "ron-english-charlie-brown": "ron-english-charlie-brown",
  "ron-english-grin": "ron-english-grin",
  "ron-english-marilyn-monroe": "ron-english-marilyn-monroe",
  "ron-english-mc-supersized": "ron-english-mc-supersized",
  "ron-english-star-skulls": "ron-english-star-skulls",
  "ron-english-temper-tots": "ron-english-temper-tots",
  "ron-english-the-simpsons": "ron-english-the-simpsons",
  "ron-english-toys": "ron-english-toys",
  "ross-bleckner-birds": "ross-bleckner-birds",
  "roy-lichtenstein-as-i-opened-fire": "roy-lichtenstein-as-i-opened-fire",
  "roy-lichtenstein-brushstrokes": "roy-lichtenstein-brushstrokes",
  "roy-lichtenstein-chinese-landscapes": "roy-lichtenstein-chinese-landscapes",
  "roy-lichtenstein-cow-going-abstract-art":
    "roy-lichtenstein-cow-going-abstract-art",
  "roy-lichtenstein-crak": "roy-lichtenstein-crak",
  "roy-lichtenstein-crying-girl": "roy-lichtenstein-crying-girl",
  "roy-lichtenstein-drowning-girl": "roy-lichtenstein-drowning-girl",
  "roy-lichtenstein-expressionist-woodcuts":
    "roy-lichtenstein-expressionist-woodcuts",
  "roy-lichtenstein-impressionism": "roy-lichtenstein-impressionism",
  "roy-lichtenstein-mickey-mouse": "roy-lichtenstein-mickey-mouse",
  "roy-lichtenstein-mirrors": "roy-lichtenstein-mirrors",
  "roy-lichtenstein-moonscapes": "roy-lichtenstein-moonscapes",
  "roy-lichtenstein-music": "roy-lichtenstein-music",
  "roy-lichtenstein-pyramids": "roy-lichtenstein-pyramids",
  "roy-lichtenstein-reverie": "roy-lichtenstein-reverie",
  "roy-lichtenstein-sandwich-and-soda": "roy-lichtenstein-sandwich-and-soda",
  "roy-lichtenstein-spray-cans": "roy-lichtenstein-spray-cans",
  "roy-lichtenstein-sunrises": "roy-lichtenstein-sunrises",
  "roy-lichtenstein-sweet-dreams-baby": "roy-lichtenstein-sweet-dreams-baby",
  "roy-lichtenstein-the-surrealist-series":
    "roy-lichtenstein-the-surrealist-series",
  "roy-lichtenstein-this-must-be-the-place":
    "roy-lichtenstein-this-must-be-the-place",
  "roy-lichtenstein-water-lilies": "roy-lichtenstein-water-lilies",
  "roy-lichtenstein-whaam": "roy-lichtenstein-whaam",
  "rufino-tamayo-watermelons": "rufino-tamayo-watermelons",
  "russell-young-brigitte-bardot": "russell-young-brigitte-bardot",
  "russell-young-diamond-dust": "russell-young-diamond-dust",
  "russell-young-elizabeth-taylor": "russell-young-elizabeth-taylor",
  "russell-young-kate-moss": "russell-young-kate-moss",
  "russell-young-magnificent-seven": "russell-young-magnificent-seven",
  "russell-young-marilyn-crying": "russell-young-marilyn-crying",
  "russell-young-marilyn-monroe": "russell-young-marilyn-monroe",
  "russell-young-mick-jagger": "russell-young-mick-jagger",
  "russell-young-pig-portraits": "russell-young-pig-portraits",
  "ruth-asawa-wire-sculpture": "ruth-asawa-wire-sculpture",
  "sally-mann-at-12": "sally-mann-at-12",
  "sally-mann-immediate-family": "sally-mann-immediate-family",
  "salvador-dali-butterflies": "salvador-dali-butterflies",
  "salvador-dali-casanova": "salvador-dali-casanova",
  "salvador-dali-dante": "salvador-dali-dante",
  "salvador-dali-don-quixote": "salvador-dali-don-quixote",
  "salvador-dali-elephants": "salvador-dali-elephants",
  "salvador-dali-faust": "salvador-dali-faust",
  "salvador-dali-fruits": "salvador-dali-fruits",
  "salvador-dali-les-amours-de-cassandre":
    "salvador-dali-les-amours-de-cassandre",
  "salvador-dali-les-diners-de-gala": "salvador-dali-les-diners-de-gala",
  "salvador-dali-lobsters": "salvador-dali-lobsters",
  "salvador-dali-melting-clocks": "salvador-dali-melting-clocks",
  "salvador-dali-memories-of-surrealism":
    "salvador-dali-memories-of-surrealism",
  "salvador-dali-mythologies": "salvador-dali-mythologies",
  "salvador-dali-playing-cards": "salvador-dali-playing-cards",
  "salvador-dali-poems": "salvador-dali-poems",
  "salvador-dali-shakespeare": "salvador-dali-shakespeare",
  "salvador-dali-signs-of-the-zodiac": "salvador-dali-signs-of-the-zodiac",
  "salvador-dali-the-bible": "salvador-dali-the-bible",
  "salvador-dali-the-divine-comedy": "salvador-dali-the-divine-comedy",
  "salvador-dali-venus": "salvador-dali-venus",
  "sam-gilliam-coffee-thyme": "sam-gilliam-coffee-thyme",
  "saul-leiter-black-and-white-photography":
    "saul-leiter-black-and-white-photography",
  "saul-leiter-color-photography": "saul-leiter-color-photography",
  "saul-leiter-new-york": "saul-leiter-new-york",
  "saul-leiter-paris": "saul-leiter-paris",
  "saul-leiter-street-photography": "saul-leiter-street-photography",
  "sean-scully-barcelona": "sean-scully-barcelona",
  "sean-scully-doric": "sean-scully-doric",
  "sebastiao-salgado-amazon": "sebastiao-salgado-amazon",
  "sebastiao-salgado-genesis": "sebastiao-salgado-genesis",
  "sebastiao-salgado-kuwait": "sebastiao-salgado-kuwait",
  "sebastiao-salgado-migrations": "sebastiao-salgado-migrations",
  "sebastiao-salgado-other-americas": "sebastiao-salgado-other-americas",
  "sebastiao-salgado-workers": "sebastiao-salgado-workers",
  "seen-tags": "seen-tags",
  "sheila-hicks-minimes": "sheila-hicks-minimes",
  "shepard-fairey-50-shades-of-black": "shepard-fairey-obey-50-shades-of-black",
  "shepard-fairey-album-covers": "shepard-fairey-obey-album-covers",
  "shepard-fairey-americana-box-set": "shepard-fairey-obey-americana-box-set",
  "shepard-fairey-andre-the-giant": "shepard-fairey-obey-andre-the-giant",
  "shepard-fairey-barack-obama": "shepard-fairey-obey-barack-obama",
  "shepard-fairey-celebrity-portraits":
    "shepard-fairey-obey-celebrity-portraits",
  "shepard-fairey-peace-signs": "shepard-fairey-obey-peace",
  "shepard-fairey-political-portraits":
    "shepard-fairey-obey-political-portraits",
  "shepard-fairey-we-the-people": "shepard-fairey-obey-we-the-people",
  "shirin-neshat-passage": "shirin-neshat-passage",
  "shirin-neshat-rapture": "shirin-neshat-rapture",
  "shirin-neshat-the-book-of-kings": "shirin-neshat-the-book-of-kings",
  "shirin-neshat-tooba": "shirin-neshat-tooba",
  "shirin-neshat-turbulent": "shirin-neshat-turbulent",
  "shirin-neshat-women-of-allah": "shirin-neshat-women-of-allah",
  "shirin-neshat-zarin": "shirin-neshat-zarin",
  "slim-aarons-italy": "slim-aarons-italy",
  "slim-aarons-lake-tahoe": "slim-aarons-lake-tahoe",
  "slim-aarons-palm-beach": "slim-aarons-palm-beach",
  "slim-aarons-pools": "slim-aarons-pools",
  "slim-aarons-poolside-gossip": "slim-aarons-poolside-gossip",
  "slim-aarons-ski": "slim-aarons-ski",
  "sol-lewitt-arcs-and-bands": "sol-lewitt-arcs-and-bands",
  "sol-lewitt-brushstrokes": "sol-lewitt-brushstrokes",
  "sol-lewitt-cubes": "sol-lewitt-cubes",
  "sol-lewitt-forms-derived-from-a-cube":
    "sol-lewitt-forms-derived-from-a-cube",
  "sol-lewitt-lines-in-four-directions": "sol-lewitt-lines-in-four-directions",
  "sol-lewitt-pyramids": "sol-lewitt-pyramids",
  "sol-lewitt-stars": "sol-lewitt-stars",
  "sol-lewitt-wall-drawings": "sol-lewitt-wall-drawings",
  "sonia-delaunay-fashion": "sonia-delaunay-fashion",
  "sonia-delaunay-pochoir": "sonia-delaunay-pochoir",
  "sophie-calle-cash-machine": "sophie-calle-cash-machine",
  "sophie-calle-exquisite-pain": "sophie-calle-exquisite-pain",
  "sophie-calle-the-blind": "sophie-calle-the-blind",
  "sophie-calle-the-sleepers": "sophie-calle-the-sleepers",
  "sophie-calle-voir-la-mer": "sophie-calle-voir-la-mer",
  "stephen-shore-american-surfaces": "stephen-shore-american-surfaces",
  "stephen-shore-andy-warhol": "stephen-shore-andy-warhol",
  "stephen-shore-california": "stephen-shore-california",
  "stephen-shore-ukraine": "stephen-shore-ukraine",
  "stephen-shore-uncommon-places": "stephen-shore-uncommon-places",
  "sterling-ruby-ashtrays": "sterling-ruby-ashtrays",
  "stik-dancers": "stik-dancers",
  "stik-liberty": "stik-liberty",
  "stik-sleeping-babies": "stik-sleeping-babies",
  "stik-walk": "stik-walk",
  "swoon-ice-queen": "swoon-ice-queen",
  "swoon-monica": "swoon-monica",
  "swoon-thalassa": "swoon-thalassa",
  "takashi-murakami-727": "takashi-murakami-727",
  "takashi-murakami-chaos": "takashi-murakami-chaos",
  "takashi-murakami-daruma": "takashi-murakami-daruma",
  "takashi-murakami-doraemon": "takashi-murakami-doraemon",
  "takashi-murakami-enso": "takashi-murakami-enso",
  "takashi-murakami-flower-balls": "takashi-murakami-flower-balls",
  "takashi-murakami-homage-to-francis-bacon":
    "takashi-murakami-homage-to-francis-bacon",
  "takashi-murakami-jellyfish-eyes": "takashi-murakami-jellyfish-eyes",
  "takashi-murakami-mr-dob": "takashi-murakami-mr-dob",
  "takashi-murakami-tan-tan-bo": "takashi-murakami-tan-tan-bo",
  "takashi-murakami-time-bokan": "takashi-murakami-time-bokan",
  "tara-donovan-cards": "tara-donovan-cards",
  "tara-donovan-pins": "tara-donovan-pins",
  "tara-donovan-rubber-bands": "tara-donovan-rubber-bands",
  "tara-donovan-slinkies": "tara-donovan-slinkies",
  "terry-oneill-amy-winehouse": "terry-oneill-amy-winehouse",
  "terry-oneill-audrey-hepburn": "terry-oneill-audrey-hepburn",
  "terry-oneill-brigitte-bardot": "terry-oneill-brigitte-bardot",
  "terry-oneill-david-bowie": "terry-oneill-david-bowie",
  "terry-oneill-elton-john": "terry-oneill-elton-john",
  "terry-oneill-faye-dunaway": "terry-oneill-faye-dunaway",
  "terry-oneill-frank-sinatra": "terry-oneill-frank-sinatra",
  "terry-oneill-james-bond": "terry-oneill-james-bond",
  "terry-oneill-kate-moss": "terry-oneill-kate-moss",
  "terry-oneill-mick-jagger": "terry-oneill-mick-jagger",
  "terry-oneill-raquel-welch": "terry-oneill-raquel-welch",
  "terry-oneill-sean-connery": "terry-oneill-sean-connery",
  "the-haas-brothers-rugs": "the-haas-brothers-rugs",
  "thomas-hart-benton-island-hay": "thomas-hart-benton-island-hay",
  "thomas-hart-benton-portrait": "thomas-hart-benton-portrait",
  "thomas-hart-benton-the-race": "thomas-hart-benton-the-race",
  "thomas-ruff-jpegs": "thomas-ruff-jpegs",
  "thomas-ruff-machines": "thomas-ruff-machines",
  "thomas-ruff-mars": "thomas-ruff-mars",
  "thomas-ruff-negatives": "thomas-ruff-negatives",
  "thomas-ruff-press": "thomas-ruff-press-plus-plus",
  "thomas-ruff-stars": "thomas-ruff-stars",
  "thomas-ruff-substrate": "thomas-ruff-substrate",
  "thomas-ruff-zycles": "thomas-ruff-zycles",
  "thomas-struth-dandelion-room": "thomas-struth-dandelion-room",
  "thomas-struth-dusseldorf": "thomas-struth-dusseldorf",
  "thomas-struth-family-portraits": "thomas-struth-family-portraits",
  "thomas-struth-israel": "thomas-struth-israel",
  "thomas-struth-museum-photographs": "thomas-struth-museum-photographs",
  "thomas-struth-new-pictures-from-paradise":
    "thomas-struth-new-pictures-from-paradise",
  "thomas-struth-places-of-worship": "thomas-struth-places-of-worship",
  "thomas-struth-unconscious-places": "thomas-struth-unconscious-places",
  "todd-hido-a-road-divided": "todd-hido-a-road-divided",
  "todd-hido-between-the-two": "todd-hido-between-the-two",
  "todd-hido-excerpts-from-silver-meadows":
    "todd-hido-excerpts-from-silver-meadows",
  "todd-hido-homes-at-night": "todd-hido-homes-at-night",
  "todd-hido-house-hunting": "todd-hido-house-hunting",
  "todd-hido-outskirts": "todd-hido-outskirts",
  "todd-hido-roaming": "todd-hido-roaming",
  "tom-sachs-chanel": "tom-sachs-chanel",
  "tom-sachs-hello-kitty": "tom-sachs-hello-kitty",
  "tom-sachs-mars": "tom-sachs-mars",
  "tom-sachs-mcdonalds": "tom-sachs-mcdonalds",
  "tom-sachs-nasa": "tom-sachs-nasa",
  "tom-sachs-space": "tom-sachs-space",
  "tom-wesselmann-bedroom-paintings": "tom-wesselmann-bedroom-paintings",
  "tom-wesselmann-great-american-nude": "tom-wesselmann-great-american-nude",
  "tom-wesselmann-monica": "tom-wesselmann-monica",
  "tom-wesselmann-smokers": "tom-wesselmann-smokers",
  "tom-wesselmann-sunset-nudes": "tom-wesselmann-sunset-nudes",
  "tomas-saraceno-clouds": "tomas-saraceno-clouds",
  "tony-cragg-bottles": "tony-cragg-bottles",
  "tony-cragg-busts": "tony-cragg-busts",
  "tony-cragg-mixed-feelings": "tony-cragg-mixed-feelings",
  "tony-cragg-stacks": "tony-cragg-stacks",
  "tony-cragg-willows": "tony-cragg-willows",
  "tracey-emin-birds": "tracey-emin-birds",
  "tracey-emin-embroidery": "tracey-emin-embroidery",
  "tracey-emin-neon-sculptures-and-prints":
    "tracey-emin-neon-sculptures-and-prints",
  "tyler-shields-birkin-bags": "tyler-shields-birkin-bags",
  "tyler-shields-bunny": "tyler-shields-bunny",
  "tyler-shields-decadence": "tyler-shields-decadence",
  "tyler-shields-mouthful": "tyler-shields-mouthful",
  "tyler-shields-provocateur": "tyler-shields-provocateur",
  "tyler-shields-rolls-royce": "tyler-shields-rolls-royce",
  "ugo-rondinone-clowns": "ugo-rondinone-clowns",
  "ugo-rondinone-human-nature": "ugo-rondinone-human-nature",
  "ugo-rondinone-rocks": "ugo-rondinone-rocks",
  "urs-fischer-small-bird-big-egg": "urs-fischer-small-bird-big-egg",
  "urs-fischer-wax-sculpture": "urs-fischer-wax-sculptures",
  "vanessa-beecroft-performance-art": "vanessa-beecroft-performance-art",
  "vanessa-beecroft-polaroids": "vanessa-beecroft-polaroids",
  "victor-vasarely-vega": "victor-vasarely-vega",
  "victor-vasarely-zebra": "victor-vasarely-zebra",
  "vija-celmins-deserts": "vija-celmins-deserts",
  "vija-celmins-drypoint": "vija-celmins-drypoint",
  "vija-celmins-night-sky": "vija-celmins-night-sky",
  "vija-celmins-oceans": "vija-celmins-oceans",
  "vija-celmins-sky": "vija-celmins-sky",
  "vija-celmins-stars": "vija-celmins-stars",
  "vija-celmins-webs": "vija-celmins-webs",
  "vik-muniz-albums": "vik-muniz-albums",
  "vik-muniz-gordian-puzzles": "vik-muniz-gordian-puzzles",
  "vik-muniz-pictures-of-magazines": "vik-muniz-pictures-of-magazines",
  "vik-muniz-pictures-of-paper": "vik-muniz-pictures-of-paper",
  "vik-muniz-postcards-from-nowhere": "vik-muniz-postcards-from-nowhere",
  "vivian-maier-chicago": "vivian-maier-chicago",
  "vivian-maier-color-photography": "vivian-maier-color-photography",
  "vivian-maier-new-york": "vivian-maier-new-york",
  "vivian-maier-shadows": "vivian-maier-shadows",
  "walker-evans-alabama": "walker-evans-alabama",
  "walker-evans-buildings": "walker-evans-buildings",
  "walker-evans-havana": "walker-evans-havana-cuba",
  "walker-evans-new-york": "walker-evans-new-york",
  "wassily-kandinsky-circles": "wassily-kandinsky-circles",
  "wayne-thiebaud-cakes": "wayne-thiebaud-cakes",
  "wayne-thiebaud-food": "wayne-thiebaud-food",
  "wayne-thiebaud-ice-cream": "wayne-thiebaud-ice-cream",
  "wayne-thiebaud-lollipops": "wayne-thiebaud-lollipops",
  "wes-lang-grateful-dead": "wes-lang-grateful-dead",
  "wifredo-lam-pleni-luna": "wifredo-lam-pleni-luna",
  "william-eggleston-14-pictures": "william-eggleston-14-pictures",
  "william-eggleston-los-alamos": "william-eggleston-los-alamos",
  "william-eggleston-memphis": "william-eggleston-memphis",
  "william-kentridge-birds": "william-kentridge-birds",
  "william-kentridge-the-nose": "william-kentridge-the-nose",
  "william-kentridge-typewriters": "william-kentridge-typewriters",
  "william-klein-abstract-photography": "william-klein-abstract-photography",
  "william-klein-atom-bomb-sky": "william-klein-atom-bomb-sky",
  "william-klein-broadway-by-light": "william-klein-broadway-by-light",
  "william-klein-candy-store": "william-klein-candy-store",
  "william-klein-club-allegro-fortissimo":
    "william-klein-club-allegro-fortissimo",
  "william-klein-guns": "william-klein-guns",
  "william-klein-london": "william-klein-london",
  "william-klein-moscow": "william-klein-moscow",
  "william-klein-new-york-city": "william-klein-new-york-city",
  "william-klein-paris": "william-klein-paris",
  "william-klein-piazza-di-spagna": "william-klein-piazza-di-spagna",
  "william-klein-rome": "william-klein-rome",
  "william-klein-street-photography": "william-klein-street-photography",
  "william-klein-tokyo": "william-klein-tokyo",
  "william-klein-vogue": "william-klein-vogue",
  "william-wegman-polaroids": "william-wegman-polaroids",
  "william-wegman-puppies": "william-wegman-puppies",
  "william-wegman-weimaraners": "william-wegman-weimaraners",
  "wolf-kahn-barns": "wolf-kahn-barns",
  "wolfgang-tillmans-freischwimmer": "wolfgang-tillmans-freischwimmer",
  "wolfgang-tillmans-silver": "wolfgang-tillmans-silver",
  "yaacov-agam-agamographs": "yaacov-agam-agamographs",
  "yayoi-kusama-infinity-nets": "yayoi-kusama-infinity-nets",
  "yayoi-kusama-polka-dots": "yayoi-kusama-polka-dots",
  "yayoi-kusama-pumpkins": "yayoi-kusama-pumpkins",
  "yoko-ono-box-of-smile": "yoko-ono-box-of-smile",
  "yoko-ono-cut-piece": "yoko-ono-cut-piece",
  "yoko-ono-grapefruit": "yoko-ono-grapefruit",
  "yoko-ono-war-is-over": "yoko-ono-war-is-over",
  "yoko-ono-wish-tree": "yoko-ono-wish-tree",
  "yves-klein-anthropometry": "yves-klein-anthropometry",
  "yves-klein-blue": "yves-klein-international-klein-blue",
  "yves-klein-globes": "yves-klein-globes",
  "yves-klein-monochromes": "yves-klein-monochromes",
  "yves-klein-tables": "yves-klein-tables",
  "yves-klein-venus": "yves-klein-venus",
  "zaha-hadid-aqua": "zaha-hadid-aqua",
  "zaha-hadid-benches": "zaha-hadid-benches",
  "zaha-hadid-chairs": "zaha-hadid-chairs",
  "zaha-hadid-chandeliers": "zaha-hadid-chandeliers",
  "zaha-hadid-lighting": "zaha-hadid-lighting",
  "zaha-hadid-liquid-glacial": "zaha-hadid-liquid-glacial",
  "zaha-hadid-shelves": "zaha-hadid-shelves",
  "zaha-hadid-sofas": "zaha-hadid-sofas",
  "zaha-hadid-tables": "zaha-hadid-tables",
  "zaha-hadid-vases": "zaha-hadid-vases",
  "zanele-muholi-faces-and-phases": "zanele-muholi-faces-and-phases",
  "zanele-muholi-only-half-the-picture": "zanele-muholi-only-half-the-picture",
  "zanele-muholi-somnyama-ngonyama": "zanele-muholi-somnyama-ngonyama",
  "zao-wou-ki-abstractions": "zao-wou-ki-zhao-wu-ji-abstractions",
  "zeng-fanzhi-mask-series": "zeng-fanzhi-ceng-fan-zhi-mask-series",
}
